export default [
  {
    "id": 207500699,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDc1MDA2OTk=",
    "name": "100_Days_of_ML_Code",
    "full_name": "girishgodage/100_Days_of_ML_Code",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/100_Days_of_ML_Code",
    "description": "These are the instructions for \"100 Days of ML Code\" By Siraj Raval on Youtube",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code",
    "forks_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/100_Days_of_ML_Code/deployments",
    "created_at": "2019-09-10T08:07:10Z",
    "updated_at": "2019-09-10T08:07:11Z",
    "pushed_at": "2018-10-19T01:15:12Z",
    "git_url": "git://github.com/girishgodage/100_Days_of_ML_Code.git",
    "ssh_url": "git@github.com:girishgodage/100_Days_of_ML_Code.git",
    "clone_url": "https://github.com/girishgodage/100_Days_of_ML_Code.git",
    "svn_url": "https://github.com/girishgodage/100_Days_of_ML_Code",
    "homepage": null,
    "size": 11,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 295762965,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTU3NjI5NjU=",
    "name": "abp",
    "full_name": "girishgodage/abp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/abp",
    "description": "Open Source Web Application Framework for ASP.NET Core",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/abp",
    "forks_url": "https://api.github.com/repos/girishgodage/abp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/abp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/abp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/abp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/abp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/abp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/abp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/abp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/abp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/abp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/abp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/abp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/abp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/abp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/abp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/abp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/abp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/abp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/abp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/abp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/abp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/abp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/abp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/abp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/abp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/abp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/abp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/abp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/abp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/abp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/abp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/abp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/abp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/abp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/abp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/abp/deployments",
    "created_at": "2020-09-15T14:59:54Z",
    "updated_at": "2020-09-15T14:59:56Z",
    "pushed_at": "2020-09-15T14:47:42Z",
    "git_url": "git://github.com/girishgodage/abp.git",
    "ssh_url": "git@github.com:girishgodage/abp.git",
    "clone_url": "https://github.com/girishgodage/abp.git",
    "svn_url": "https://github.com/girishgodage/abp",
    "homepage": "https://abp.io/",
    "size": 161411,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "lgpl-3.0",
      "name": "GNU Lesser General Public License v3.0",
      "spdx_id": "LGPL-3.0",
      "url": "https://api.github.com/licenses/lgpl-3.0",
      "node_id": "MDc6TGljZW5zZTEy"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "dev"
  },
  {
    "id": 295763594,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTU3NjM1OTQ=",
    "name": "abp-samples",
    "full_name": "girishgodage/abp-samples",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/abp-samples",
    "description": "Sample solutions built with the ABP Framework",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/abp-samples",
    "forks_url": "https://api.github.com/repos/girishgodage/abp-samples/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/abp-samples/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/abp-samples/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/abp-samples/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/abp-samples/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/abp-samples/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/abp-samples/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/abp-samples/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/abp-samples/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/abp-samples/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/abp-samples/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/abp-samples/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/abp-samples/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/abp-samples/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/abp-samples/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/abp-samples/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/abp-samples/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/abp-samples/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/abp-samples/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/abp-samples/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/abp-samples/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/abp-samples/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/abp-samples/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/abp-samples/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/abp-samples/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/abp-samples/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/abp-samples/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/abp-samples/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/abp-samples/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/abp-samples/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/abp-samples/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/abp-samples/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/abp-samples/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/abp-samples/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/abp-samples/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/abp-samples/deployments",
    "created_at": "2020-09-15T15:02:11Z",
    "updated_at": "2020-09-15T15:02:13Z",
    "pushed_at": "2020-09-08T12:10:13Z",
    "git_url": "git://github.com/girishgodage/abp-samples.git",
    "ssh_url": "git@github.com:girishgodage/abp-samples.git",
    "clone_url": "https://github.com/girishgodage/abp-samples.git",
    "svn_url": "https://github.com/girishgodage/abp-samples",
    "homepage": "https://abp.io/",
    "size": 21342,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 219929919,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTk5Mjk5MTk=",
    "name": "Adminator-admin-dashboard",
    "full_name": "girishgodage/Adminator-admin-dashboard",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Adminator-admin-dashboard",
    "description": "Adminator is a easy to use and well design admin dashboard template for web apps, websites, services and more",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard",
    "forks_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Adminator-admin-dashboard/deployments",
    "created_at": "2019-11-06T06:45:11Z",
    "updated_at": "2019-11-06T06:45:13Z",
    "pushed_at": "2019-11-03T17:03:07Z",
    "git_url": "git://github.com/girishgodage/Adminator-admin-dashboard.git",
    "ssh_url": "git@github.com:girishgodage/Adminator-admin-dashboard.git",
    "clone_url": "https://github.com/girishgodage/Adminator-admin-dashboard.git",
    "svn_url": "https://github.com/girishgodage/Adminator-admin-dashboard",
    "homepage": "https://colorlib.com/polygon/adminator/index.html",
    "size": 1692,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 287936242,
    "node_id": "MDEwOlJlcG9zaXRvcnkyODc5MzYyNDI=",
    "name": "adminlte-3-angular",
    "full_name": "girishgodage/adminlte-3-angular",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/adminlte-3-angular",
    "description": "Angular 9 start-up project with AdminLTE 3 template",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/adminlte-3-angular",
    "forks_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/adminlte-3-angular/deployments",
    "created_at": "2020-08-16T12:07:47Z",
    "updated_at": "2020-08-16T12:07:48Z",
    "pushed_at": "2020-07-30T13:06:57Z",
    "git_url": "git://github.com/girishgodage/adminlte-3-angular.git",
    "ssh_url": "git@github.com:girishgodage/adminlte-3-angular.git",
    "clone_url": "https://github.com/girishgodage/adminlte-3-angular.git",
    "svn_url": "https://github.com/girishgodage/adminlte-3-angular",
    "homepage": "https://adminlte-3-angular.herokuapp.com/",
    "size": 3827,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224430814,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzA4MTQ=",
    "name": "AdminLTE-ASP-NET-MVC",
    "full_name": "girishgodage/AdminLTE-ASP-NET-MVC",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AdminLTE-ASP-NET-MVC",
    "description": "Asp.Net Example Version of Beautiful AdminLTE Template",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC",
    "forks_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AdminLTE-ASP-NET-MVC/deployments",
    "created_at": "2019-11-27T12:53:55Z",
    "updated_at": "2019-11-27T12:53:56Z",
    "pushed_at": "2019-02-13T14:03:28Z",
    "git_url": "git://github.com/girishgodage/AdminLTE-ASP-NET-MVC.git",
    "ssh_url": "git@github.com:girishgodage/AdminLTE-ASP-NET-MVC.git",
    "clone_url": "https://github.com/girishgodage/AdminLTE-ASP-NET-MVC.git",
    "svn_url": "https://github.com/girishgodage/AdminLTE-ASP-NET-MVC",
    "homepage": "https://adminlte-mvc5.azurewebsites.net/",
    "size": 10337,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224430962,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzA5NjI=",
    "name": "adminlte-aspnetcore2-version",
    "full_name": "girishgodage/adminlte-aspnetcore2-version",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/adminlte-aspnetcore2-version",
    "description": "Asp.Net Example version of famous and beautiful AdminLTE control panel themes and template.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version",
    "forks_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/adminlte-aspnetcore2-version/deployments",
    "created_at": "2019-11-27T12:54:41Z",
    "updated_at": "2019-11-27T12:54:43Z",
    "pushed_at": "2019-10-03T10:19:59Z",
    "git_url": "git://github.com/girishgodage/adminlte-aspnetcore2-version.git",
    "ssh_url": "git@github.com:girishgodage/adminlte-aspnetcore2-version.git",
    "clone_url": "https://github.com/girishgodage/adminlte-aspnetcore2-version.git",
    "svn_url": "https://github.com/girishgodage/adminlte-aspnetcore2-version",
    "homepage": "http://adminlte-template.indotalent.com",
    "size": 17567,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224475290,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0NzUyOTA=",
    "name": "AdminLTE-Starter-Kit",
    "full_name": "girishgodage/AdminLTE-Starter-Kit",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AdminLTE-Starter-Kit",
    "description": "AdminLTE Starter Kit for ASP.NET Core",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit",
    "forks_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AdminLTE-Starter-Kit/deployments",
    "created_at": "2019-11-27T16:42:33Z",
    "updated_at": "2019-11-27T16:42:35Z",
    "pushed_at": "2019-06-20T14:38:14Z",
    "git_url": "git://github.com/girishgodage/AdminLTE-Starter-Kit.git",
    "ssh_url": "git@github.com:girishgodage/AdminLTE-Starter-Kit.git",
    "clone_url": "https://github.com/girishgodage/AdminLTE-Starter-Kit.git",
    "svn_url": "https://github.com/girishgodage/AdminLTE-Starter-Kit",
    "homepage": "https://dotnet.express",
    "size": 16800,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224476056,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0NzYwNTY=",
    "name": "AdminLTE2.RazorPages",
    "full_name": "girishgodage/AdminLTE2.RazorPages",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AdminLTE2.RazorPages",
    "description": "ASP.NET Core Razor Pages version of the original AdminLTE dashboard https://adminlte.io",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages",
    "forks_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AdminLTE2.RazorPages/deployments",
    "created_at": "2019-11-27T16:46:34Z",
    "updated_at": "2019-11-27T16:46:36Z",
    "pushed_at": "2019-10-25T21:35:03Z",
    "git_url": "git://github.com/girishgodage/AdminLTE2.RazorPages.git",
    "ssh_url": "git@github.com:girishgodage/AdminLTE2.RazorPages.git",
    "clone_url": "https://github.com/girishgodage/AdminLTE2.RazorPages.git",
    "svn_url": "https://github.com/girishgodage/AdminLTE2.RazorPages",
    "homepage": "",
    "size": 14298,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 287868168,
    "node_id": "MDEwOlJlcG9zaXRvcnkyODc4NjgxNjg=",
    "name": "adminlte3-with-angular9",
    "full_name": "girishgodage/adminlte3-with-angular9",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/adminlte3-with-angular9",
    "description": "Please run command npm install to install all the node modules present in package.json and then you should be good to run the application.  ",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9",
    "forks_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/adminlte3-with-angular9/deployments",
    "created_at": "2020-08-16T03:45:02Z",
    "updated_at": "2020-08-16T03:45:03Z",
    "pushed_at": "2020-04-18T08:44:48Z",
    "git_url": "git://github.com/girishgodage/adminlte3-with-angular9.git",
    "ssh_url": "git@github.com:girishgodage/adminlte3-with-angular9.git",
    "clone_url": "https://github.com/girishgodage/adminlte3-with-angular9.git",
    "svn_url": "https://github.com/girishgodage/adminlte3-with-angular9",
    "homepage": null,
    "size": 13542,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 287889857,
    "node_id": "MDEwOlJlcG9zaXRvcnkyODc4ODk4NTc=",
    "name": "AdminLte3Ang10",
    "full_name": "girishgodage/AdminLte3Ang10",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AdminLte3Ang10",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10",
    "forks_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AdminLte3Ang10/deployments",
    "created_at": "2020-08-16T06:46:39Z",
    "updated_at": "2020-08-16T07:22:38Z",
    "pushed_at": "2020-08-16T07:22:35Z",
    "git_url": "git://github.com/girishgodage/AdminLte3Ang10.git",
    "ssh_url": "git@github.com:girishgodage/AdminLte3Ang10.git",
    "clone_url": "https://github.com/girishgodage/AdminLte3Ang10.git",
    "svn_url": "https://github.com/girishgodage/AdminLte3Ang10",
    "homepage": null,
    "size": 3174,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 303643842,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDM2NDM4NDI=",
    "name": "ai-personal-assistant",
    "full_name": "girishgodage/ai-personal-assistant",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/ai-personal-assistant",
    "description": "A project to build an AI voice assistant using Python . The Voice assistant interacts with the humans to perform basic tasks.",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/ai-personal-assistant",
    "forks_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/ai-personal-assistant/deployments",
    "created_at": "2020-10-13T08:53:12Z",
    "updated_at": "2020-10-13T12:45:19Z",
    "pushed_at": "2020-10-13T12:45:17Z",
    "git_url": "git://github.com/girishgodage/ai-personal-assistant.git",
    "ssh_url": "git@github.com:girishgodage/ai-personal-assistant.git",
    "clone_url": "https://github.com/girishgodage/ai-personal-assistant.git",
    "svn_url": "https://github.com/girishgodage/ai-personal-assistant",
    "homepage": null,
    "size": 233,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 327829256,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjc4MjkyNTY=",
    "name": "AI_news_react_app",
    "full_name": "girishgodage/AI_news_react_app",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AI_news_react_app",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/AI_news_react_app",
    "forks_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AI_news_react_app/deployments",
    "created_at": "2021-01-08T07:25:31Z",
    "updated_at": "2021-01-19T06:07:38Z",
    "pushed_at": "2021-01-08T07:33:34Z",
    "git_url": "git://github.com/girishgodage/AI_news_react_app.git",
    "ssh_url": "git@github.com:girishgodage/AI_news_react_app.git",
    "clone_url": "https://github.com/girishgodage/AI_news_react_app.git",
    "svn_url": "https://github.com/girishgodage/AI_news_react_app",
    "homepage": null,
    "size": 1088,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 237932059,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzc5MzIwNTk=",
    "name": "amazon-forecast-samples",
    "full_name": "girishgodage/amazon-forecast-samples",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/amazon-forecast-samples",
    "description": "Notebooks and examples on how to onboard and use various features of Amazon Forecast.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples",
    "forks_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/amazon-forecast-samples/deployments",
    "created_at": "2020-02-03T09:46:25Z",
    "updated_at": "2020-02-03T09:46:27Z",
    "pushed_at": "2020-01-31T01:13:02Z",
    "git_url": "git://github.com/girishgodage/amazon-forecast-samples.git",
    "ssh_url": "git@github.com:girishgodage/amazon-forecast-samples.git",
    "clone_url": "https://github.com/girishgodage/amazon-forecast-samples.git",
    "svn_url": "https://github.com/girishgodage/amazon-forecast-samples",
    "homepage": "",
    "size": 43083,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 237900556,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzc5MDA1NTY=",
    "name": "Amazon-Personalize",
    "full_name": "girishgodage/Amazon-Personalize",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Amazon-Personalize",
    "description": "Real-time personalization and recommendation service, based on the same Artificial Intelligence technology used at Amazon.com",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Amazon-Personalize",
    "forks_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Amazon-Personalize/deployments",
    "created_at": "2020-02-03T06:33:35Z",
    "updated_at": "2020-02-03T06:33:39Z",
    "pushed_at": "2019-07-20T19:50:00Z",
    "git_url": "git://github.com/girishgodage/Amazon-Personalize.git",
    "ssh_url": "git@github.com:girishgodage/Amazon-Personalize.git",
    "clone_url": "https://github.com/girishgodage/Amazon-Personalize.git",
    "svn_url": "https://github.com/girishgodage/Amazon-Personalize",
    "homepage": null,
    "size": 17,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 237894906,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzc4OTQ5MDY=",
    "name": "amazon-personalize-samples",
    "full_name": "girishgodage/amazon-personalize-samples",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/amazon-personalize-samples",
    "description": "Notebooks and examples on how to onboard and use various features of Amazon Personalize",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples",
    "forks_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/amazon-personalize-samples/deployments",
    "created_at": "2020-02-03T05:52:01Z",
    "updated_at": "2020-02-03T05:52:03Z",
    "pushed_at": "2019-12-01T17:03:34Z",
    "git_url": "git://github.com/girishgodage/amazon-personalize-samples.git",
    "ssh_url": "git@github.com:girishgodage/amazon-personalize-samples.git",
    "clone_url": "https://github.com/girishgodage/amazon-personalize-samples.git",
    "svn_url": "https://github.com/girishgodage/amazon-personalize-samples",
    "homepage": null,
    "size": 8820,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 238133999,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzgxMzM5OTk=",
    "name": "amazon-rekognition-video-analyzer",
    "full_name": "girishgodage/amazon-rekognition-video-analyzer",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/amazon-rekognition-video-analyzer",
    "description": "A working prototype for capturing frames off of a live MJPEG video stream, identifying objects in near real-time using deep learning, and triggering actions based on an objects watch list. ",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer",
    "forks_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/amazon-rekognition-video-analyzer/deployments",
    "created_at": "2020-02-04T05:54:51Z",
    "updated_at": "2020-02-04T05:54:52Z",
    "pushed_at": "2019-05-24T06:48:12Z",
    "git_url": "git://github.com/girishgodage/amazon-rekognition-video-analyzer.git",
    "ssh_url": "git@github.com:girishgodage/amazon-rekognition-video-analyzer.git",
    "clone_url": "https://github.com/girishgodage/amazon-rekognition-video-analyzer.git",
    "svn_url": "https://github.com/girishgodage/amazon-rekognition-video-analyzer",
    "homepage": "",
    "size": 810,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 245078688,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDUwNzg2ODg=",
    "name": "amazon-textract-code-samples",
    "full_name": "girishgodage/amazon-textract-code-samples",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/amazon-textract-code-samples",
    "description": "Amazon Textract Code Samples",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples",
    "forks_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/amazon-textract-code-samples/deployments",
    "created_at": "2020-03-05T05:39:52Z",
    "updated_at": "2020-03-05T05:39:54Z",
    "pushed_at": "2020-02-27T20:31:10Z",
    "git_url": "git://github.com/girishgodage/amazon-textract-code-samples.git",
    "ssh_url": "git@github.com:girishgodage/amazon-textract-code-samples.git",
    "clone_url": "https://github.com/girishgodage/amazon-textract-code-samples.git",
    "svn_url": "https://github.com/girishgodage/amazon-textract-code-samples",
    "homepage": null,
    "size": 750,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 238164629,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzgxNjQ2Mjk=",
    "name": "amazon-textract-serverless-large-scale-document-processing",
    "full_name": "girishgodage/amazon-textract-serverless-large-scale-document-processing",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/amazon-textract-serverless-large-scale-document-processing",
    "description": "Process documents at scale using Amazon Textract",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing",
    "forks_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/amazon-textract-serverless-large-scale-document-processing/deployments",
    "created_at": "2020-02-04T09:08:18Z",
    "updated_at": "2020-02-04T09:08:20Z",
    "pushed_at": "2019-11-01T13:14:30Z",
    "git_url": "git://github.com/girishgodage/amazon-textract-serverless-large-scale-document-processing.git",
    "ssh_url": "git@github.com:girishgodage/amazon-textract-serverless-large-scale-document-processing.git",
    "clone_url": "https://github.com/girishgodage/amazon-textract-serverless-large-scale-document-processing.git",
    "svn_url": "https://github.com/girishgodage/amazon-textract-serverless-large-scale-document-processing",
    "homepage": "",
    "size": 2049,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "apache-2.0",
      "name": "Apache License 2.0",
      "spdx_id": "Apache-2.0",
      "url": "https://api.github.com/licenses/apache-2.0",
      "node_id": "MDc6TGljZW5zZTI="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 239482881,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzk0ODI4ODE=",
    "name": "AmazonEmployeeAccess",
    "full_name": "girishgodage/AmazonEmployeeAccess",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AmazonEmployeeAccess",
    "description": " Design an algorithm to accurately predict the access status to certain resources of employees",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess",
    "forks_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AmazonEmployeeAccess/deployments",
    "created_at": "2020-02-10T10:18:05Z",
    "updated_at": "2020-02-10T10:18:07Z",
    "pushed_at": "2019-12-07T16:19:27Z",
    "git_url": "git://github.com/girishgodage/AmazonEmployeeAccess.git",
    "ssh_url": "git@github.com:girishgodage/AmazonEmployeeAccess.git",
    "clone_url": "https://github.com/girishgodage/AmazonEmployeeAccess.git",
    "svn_url": "https://github.com/girishgodage/AmazonEmployeeAccess",
    "homepage": null,
    "size": 12877,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 198156105,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTgxNTYxMDU=",
    "name": "androidMyTodoApp",
    "full_name": "girishgodage/androidMyTodoApp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/androidMyTodoApp",
    "description": "Android mobile My To do Application",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/androidMyTodoApp",
    "forks_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/androidMyTodoApp/deployments",
    "created_at": "2019-07-22T05:50:42Z",
    "updated_at": "2019-07-23T04:32:45Z",
    "pushed_at": "2019-07-23T04:32:43Z",
    "git_url": "git://github.com/girishgodage/androidMyTodoApp.git",
    "ssh_url": "git@github.com:girishgodage/androidMyTodoApp.git",
    "clone_url": "https://github.com/girishgodage/androidMyTodoApp.git",
    "svn_url": "https://github.com/girishgodage/androidMyTodoApp",
    "homepage": null,
    "size": 271,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 307681623,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDc2ODE2MjM=",
    "name": "ang10MatDatatabeCrud",
    "full_name": "girishgodage/ang10MatDatatabeCrud",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/ang10MatDatatabeCrud",
    "description": "Mat Datatable with Angular 10",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud",
    "forks_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/ang10MatDatatabeCrud/deployments",
    "created_at": "2020-10-27T11:43:53Z",
    "updated_at": "2021-01-19T09:52:05Z",
    "pushed_at": "2020-10-27T13:56:18Z",
    "git_url": "git://github.com/girishgodage/ang10MatDatatabeCrud.git",
    "ssh_url": "git@github.com:girishgodage/ang10MatDatatabeCrud.git",
    "clone_url": "https://github.com/girishgodage/ang10MatDatatabeCrud.git",
    "svn_url": "https://github.com/girishgodage/ang10MatDatatabeCrud",
    "homepage": null,
    "size": 155,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 309273867,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDkyNzM4Njc=",
    "name": "angBlogApp",
    "full_name": "girishgodage/angBlogApp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/angBlogApp",
    "description": "Angular 10 Blog App",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/angBlogApp",
    "forks_url": "https://api.github.com/repos/girishgodage/angBlogApp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/angBlogApp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/angBlogApp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/angBlogApp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/angBlogApp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/angBlogApp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/angBlogApp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/angBlogApp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/angBlogApp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/angBlogApp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/angBlogApp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/angBlogApp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/angBlogApp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/angBlogApp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/angBlogApp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/angBlogApp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/angBlogApp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/angBlogApp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/angBlogApp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/angBlogApp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/angBlogApp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/angBlogApp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/angBlogApp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/angBlogApp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/angBlogApp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/angBlogApp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/angBlogApp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/angBlogApp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/angBlogApp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/angBlogApp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/angBlogApp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/angBlogApp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/angBlogApp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/angBlogApp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/angBlogApp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/angBlogApp/deployments",
    "created_at": "2020-11-02T06:05:30Z",
    "updated_at": "2021-01-19T09:51:55Z",
    "pushed_at": "2020-11-02T06:35:32Z",
    "git_url": "git://github.com/girishgodage/angBlogApp.git",
    "ssh_url": "git@github.com:girishgodage/angBlogApp.git",
    "clone_url": "https://github.com/girishgodage/angBlogApp.git",
    "svn_url": "https://github.com/girishgodage/angBlogApp",
    "homepage": null,
    "size": 286,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 192784513,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTI3ODQ1MTM=",
    "name": "Angular-7-CRUD-with-Web-API",
    "full_name": "girishgodage/Angular-7-CRUD-with-Web-API",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Angular-7-CRUD-with-Web-API",
    "description": "Angular 7 CRUD with Web API",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API",
    "forks_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Angular-7-CRUD-with-Web-API/deployments",
    "created_at": "2019-06-19T18:28:32Z",
    "updated_at": "2019-06-19T18:28:37Z",
    "pushed_at": "2019-01-15T09:24:28Z",
    "git_url": "git://github.com/girishgodage/Angular-7-CRUD-with-Web-API.git",
    "ssh_url": "git@github.com:girishgodage/Angular-7-CRUD-with-Web-API.git",
    "clone_url": "https://github.com/girishgodage/Angular-7-CRUD-with-Web-API.git",
    "svn_url": "https://github.com/girishgodage/Angular-7-CRUD-with-Web-API",
    "homepage": null,
    "size": 47521,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 201052521,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDEwNTI1MjE=",
    "name": "Angular-7-Master-Detail-CRUD-with-Web-API",
    "full_name": "girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API",
    "description": "Angular 7 Master Detail CRUD with Web API",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API",
    "forks_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API/deployments",
    "created_at": "2019-08-07T13:07:17Z",
    "updated_at": "2019-08-07T13:07:22Z",
    "pushed_at": "2019-01-15T09:24:50Z",
    "git_url": "git://github.com/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API.git",
    "ssh_url": "git@github.com:girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API.git",
    "clone_url": "https://github.com/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API.git",
    "svn_url": "https://github.com/girishgodage/Angular-7-Master-Detail-CRUD-with-Web-API",
    "homepage": null,
    "size": 47741,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 195201850,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTUyMDE4NTA=",
    "name": "Angular-7-Project-with-ASP.NET-CORE-APIS",
    "full_name": "girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS",
    "description": "Angular 7 Application with ASP.NET CORE APIS ",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS",
    "forks_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS/deployments",
    "created_at": "2019-07-04T08:33:12Z",
    "updated_at": "2019-07-04T08:33:15Z",
    "pushed_at": "2019-06-06T17:50:31Z",
    "git_url": "git://github.com/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS.git",
    "ssh_url": "git@github.com:girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS.git",
    "clone_url": "https://github.com/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS.git",
    "svn_url": "https://github.com/girishgodage/Angular-7-Project-with-ASP.NET-CORE-APIS",
    "homepage": "",
    "size": 13385,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 306342918,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDYzNDI5MTg=",
    "name": "angular-admin-lte",
    "full_name": "girishgodage/angular-admin-lte",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/angular-admin-lte",
    "description": "AdminLte for Angular 2",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/angular-admin-lte",
    "forks_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/angular-admin-lte/deployments",
    "created_at": "2020-10-22T13:16:55Z",
    "updated_at": "2020-10-22T13:16:57Z",
    "pushed_at": "2020-08-07T23:21:24Z",
    "git_url": "git://github.com/girishgodage/angular-admin-lte.git",
    "ssh_url": "git@github.com:girishgodage/angular-admin-lte.git",
    "clone_url": "https://github.com/girishgodage/angular-admin-lte.git",
    "svn_url": "https://github.com/girishgodage/angular-admin-lte",
    "homepage": "https://mika-el.github.io/angular-admin-lte/",
    "size": 7721,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 322278275,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjIyNzgyNzU=",
    "name": "Angular-Computer-Vision-Azure-Cognitive-Services",
    "full_name": "girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services",
    "description": "An Optical Character Recognition (OCR) using Blazor and Azure Computer Vision Cognitive Services",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services",
    "forks_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services/deployments",
    "created_at": "2020-12-17T11:46:42Z",
    "updated_at": "2020-12-17T11:46:45Z",
    "pushed_at": "2020-09-11T07:56:53Z",
    "git_url": "git://github.com/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services.git",
    "ssh_url": "git@github.com:girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services.git",
    "clone_url": "https://github.com/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services.git",
    "svn_url": "https://github.com/girishgodage/Angular-Computer-Vision-Azure-Cognitive-Services",
    "homepage": "",
    "size": 12055,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 307907892,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDc5MDc4OTI=",
    "name": "angular-covid-19",
    "full_name": "girishgodage/angular-covid-19",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/angular-covid-19",
    "description": "COVID-19 Stats Tracker App | Built in Angular | Preview:",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/angular-covid-19",
    "forks_url": "https://api.github.com/repos/girishgodage/angular-covid-19/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/angular-covid-19/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/angular-covid-19/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/angular-covid-19/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/angular-covid-19/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/angular-covid-19/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/angular-covid-19/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/angular-covid-19/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/angular-covid-19/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/angular-covid-19/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/angular-covid-19/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/angular-covid-19/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/angular-covid-19/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/angular-covid-19/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/angular-covid-19/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/angular-covid-19/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/angular-covid-19/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/angular-covid-19/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/angular-covid-19/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/angular-covid-19/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/angular-covid-19/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/angular-covid-19/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/angular-covid-19/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/angular-covid-19/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/angular-covid-19/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/angular-covid-19/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/angular-covid-19/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/angular-covid-19/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/angular-covid-19/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/angular-covid-19/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/angular-covid-19/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/angular-covid-19/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/angular-covid-19/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/angular-covid-19/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/angular-covid-19/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/angular-covid-19/deployments",
    "created_at": "2020-10-28T04:38:26Z",
    "updated_at": "2020-10-28T04:38:29Z",
    "pushed_at": "2020-05-12T08:08:27Z",
    "git_url": "git://github.com/girishgodage/angular-covid-19.git",
    "ssh_url": "git@github.com:girishgodage/angular-covid-19.git",
    "clone_url": "https://github.com/girishgodage/angular-covid-19.git",
    "svn_url": "https://github.com/girishgodage/angular-covid-19",
    "homepage": "https://covid-19-c69ff.web.app",
    "size": 3531,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "materialize-css"
  },
  {
    "id": 314766610,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMTQ3NjY2MTA=",
    "name": "angular-erp-system",
    "full_name": "girishgodage/angular-erp-system",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/angular-erp-system",
    "description": "Created with StackBlitz ⚡️",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/angular-erp-system",
    "forks_url": "https://api.github.com/repos/girishgodage/angular-erp-system/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/angular-erp-system/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/angular-erp-system/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/angular-erp-system/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/angular-erp-system/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/angular-erp-system/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/angular-erp-system/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/angular-erp-system/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/angular-erp-system/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/angular-erp-system/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/angular-erp-system/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/angular-erp-system/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/angular-erp-system/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/angular-erp-system/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/angular-erp-system/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/angular-erp-system/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/angular-erp-system/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/angular-erp-system/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/angular-erp-system/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/angular-erp-system/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/angular-erp-system/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/angular-erp-system/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/angular-erp-system/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/angular-erp-system/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/angular-erp-system/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/angular-erp-system/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/angular-erp-system/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/angular-erp-system/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/angular-erp-system/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/angular-erp-system/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/angular-erp-system/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/angular-erp-system/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/angular-erp-system/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/angular-erp-system/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/angular-erp-system/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/angular-erp-system/deployments",
    "created_at": "2020-11-21T08:27:06Z",
    "updated_at": "2020-11-21T08:27:08Z",
    "pushed_at": "2020-09-07T22:46:56Z",
    "git_url": "git://github.com/girishgodage/angular-erp-system.git",
    "ssh_url": "git@github.com:girishgodage/angular-erp-system.git",
    "clone_url": "https://github.com/girishgodage/angular-erp-system.git",
    "svn_url": "https://github.com/girishgodage/angular-erp-system",
    "homepage": "https://stackblitz.com/edit/angular-erp-system",
    "size": 1157,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 193629970,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTM2Mjk5NzA=",
    "name": "Angular-Image-Gallery-with-Firebase",
    "full_name": "girishgodage/Angular-Image-Gallery-with-Firebase",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Angular-Image-Gallery-with-Firebase",
    "description": "Angular Image Gallery with Firebase",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase",
    "forks_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Angular-Image-Gallery-with-Firebase/deployments",
    "created_at": "2019-06-25T03:43:57Z",
    "updated_at": "2019-06-25T03:44:00Z",
    "pushed_at": "2019-06-04T12:00:20Z",
    "git_url": "git://github.com/girishgodage/Angular-Image-Gallery-with-Firebase.git",
    "ssh_url": "git@github.com:girishgodage/Angular-Image-Gallery-with-Firebase.git",
    "clone_url": "https://github.com/girishgodage/Angular-Image-Gallery-with-Firebase.git",
    "svn_url": "https://github.com/girishgodage/Angular-Image-Gallery-with-Firebase",
    "homepage": null,
    "size": 146,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "TypeScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 307371351,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDczNzEzNTE=",
    "name": "angular10adminlte3",
    "full_name": "girishgodage/angular10adminlte3",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/angular10adminlte3",
    "description": "adminlte3 with angular 10 template",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/angular10adminlte3",
    "forks_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/angular10adminlte3/deployments",
    "created_at": "2020-10-26T12:52:30Z",
    "updated_at": "2021-01-19T09:52:07Z",
    "pushed_at": "2020-10-26T12:55:25Z",
    "git_url": "git://github.com/girishgodage/angular10adminlte3.git",
    "ssh_url": "git@github.com:girishgodage/angular10adminlte3.git",
    "clone_url": "https://github.com/girishgodage/angular10adminlte3.git",
    "svn_url": "https://github.com/girishgodage/angular10adminlte3",
    "homepage": null,
    "size": 3203,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 193205722,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTMyMDU3MjI=",
    "name": "angular7MaterialApp",
    "full_name": "girishgodage/angular7MaterialApp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/angular7MaterialApp",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/angular7MaterialApp",
    "forks_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/angular7MaterialApp/deployments",
    "created_at": "2019-06-22T07:33:38Z",
    "updated_at": "2021-01-19T09:51:51Z",
    "pushed_at": "2020-12-11T09:44:13Z",
    "git_url": "git://github.com/girishgodage/angular7MaterialApp.git",
    "ssh_url": "git@github.com:girishgodage/angular7MaterialApp.git",
    "clone_url": "https://github.com/girishgodage/angular7MaterialApp.git",
    "svn_url": "https://github.com/girishgodage/angular7MaterialApp",
    "homepage": null,
    "size": 661,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 9,
    "license": null,
    "forks": 0,
    "open_issues": 9,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 306829450,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDY4Mjk0NTA=",
    "name": "angularAdminLTE",
    "full_name": "girishgodage/angularAdminLTE",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/angularAdminLTE",
    "description": "Angular Version of AdminLTE template",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/angularAdminLTE",
    "forks_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/angularAdminLTE/deployments",
    "created_at": "2020-10-24T07:26:17Z",
    "updated_at": "2020-10-24T07:26:19Z",
    "pushed_at": "2020-09-11T00:55:46Z",
    "git_url": "git://github.com/girishgodage/angularAdminLTE.git",
    "ssh_url": "git@github.com:girishgodage/angularAdminLTE.git",
    "clone_url": "https://github.com/girishgodage/angularAdminLTE.git",
    "svn_url": "https://github.com/girishgodage/angularAdminLTE",
    "homepage": null,
    "size": 5290,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 199394278,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTkzOTQyNzg=",
    "name": "AngularChatbot",
    "full_name": "girishgodage/AngularChatbot",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AngularChatbot",
    "description": "Chatbot in Angular With DialogFlow API.ai",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/AngularChatbot",
    "forks_url": "https://api.github.com/repos/girishgodage/AngularChatbot/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AngularChatbot/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AngularChatbot/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AngularChatbot/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AngularChatbot/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AngularChatbot/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AngularChatbot/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AngularChatbot/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AngularChatbot/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AngularChatbot/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AngularChatbot/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AngularChatbot/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AngularChatbot/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AngularChatbot/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AngularChatbot/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AngularChatbot/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AngularChatbot/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AngularChatbot/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AngularChatbot/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AngularChatbot/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AngularChatbot/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AngularChatbot/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AngularChatbot/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AngularChatbot/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AngularChatbot/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AngularChatbot/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AngularChatbot/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AngularChatbot/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AngularChatbot/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AngularChatbot/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AngularChatbot/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AngularChatbot/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AngularChatbot/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AngularChatbot/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AngularChatbot/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AngularChatbot/deployments",
    "created_at": "2019-07-29T06:43:14Z",
    "updated_at": "2021-01-19T09:51:42Z",
    "pushed_at": "2020-12-11T17:22:35Z",
    "git_url": "git://github.com/girishgodage/AngularChatbot.git",
    "ssh_url": "git@github.com:girishgodage/AngularChatbot.git",
    "clone_url": "https://github.com/girishgodage/AngularChatbot.git",
    "svn_url": "https://github.com/girishgodage/AngularChatbot",
    "homepage": null,
    "size": 998,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 8,
    "license": null,
    "forks": 0,
    "open_issues": 8,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 322279748,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjIyNzk3NDg=",
    "name": "AngularComputerVisionAzureCognitiveServices",
    "full_name": "girishgodage/AngularComputerVisionAzureCognitiveServices",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AngularComputerVisionAzureCognitiveServices",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices",
    "forks_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AngularComputerVisionAzureCognitiveServices/deployments",
    "created_at": "2020-12-17T11:52:54Z",
    "updated_at": "2021-01-19T09:51:35Z",
    "pushed_at": "2020-12-17T12:17:30Z",
    "git_url": "git://github.com/girishgodage/AngularComputerVisionAzureCognitiveServices.git",
    "ssh_url": "git@github.com:girishgodage/AngularComputerVisionAzureCognitiveServices.git",
    "clone_url": "https://github.com/girishgodage/AngularComputerVisionAzureCognitiveServices.git",
    "svn_url": "https://github.com/girishgodage/AngularComputerVisionAzureCognitiveServices",
    "homepage": null,
    "size": 64307,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 63127132,
    "node_id": "MDEwOlJlcG9zaXRvcnk2MzEyNzEzMg==",
    "name": "AngularTutorial",
    "full_name": "girishgodage/AngularTutorial",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AngularTutorial",
    "description": "AngularTutorial ",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/AngularTutorial",
    "forks_url": "https://api.github.com/repos/girishgodage/AngularTutorial/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AngularTutorial/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AngularTutorial/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AngularTutorial/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AngularTutorial/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AngularTutorial/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AngularTutorial/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AngularTutorial/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AngularTutorial/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AngularTutorial/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AngularTutorial/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AngularTutorial/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AngularTutorial/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AngularTutorial/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AngularTutorial/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AngularTutorial/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AngularTutorial/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AngularTutorial/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AngularTutorial/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AngularTutorial/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AngularTutorial/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AngularTutorial/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AngularTutorial/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AngularTutorial/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AngularTutorial/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AngularTutorial/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AngularTutorial/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AngularTutorial/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AngularTutorial/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AngularTutorial/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AngularTutorial/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AngularTutorial/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AngularTutorial/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AngularTutorial/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AngularTutorial/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AngularTutorial/deployments",
    "created_at": "2016-07-12T04:48:05Z",
    "updated_at": "2016-07-12T05:07:58Z",
    "pushed_at": "2016-07-12T09:20:02Z",
    "git_url": "git://github.com/girishgodage/AngularTutorial.git",
    "ssh_url": "git@github.com:girishgodage/AngularTutorial.git",
    "clone_url": "https://github.com/girishgodage/AngularTutorial.git",
    "svn_url": "https://github.com/girishgodage/AngularTutorial",
    "homepage": null,
    "size": 28817,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 210145222,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTAxNDUyMjI=",
    "name": "AngularTutorialAgendaApp",
    "full_name": "girishgodage/AngularTutorialAgendaApp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/AngularTutorialAgendaApp",
    "description": "Angular Tutorial App",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp",
    "forks_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/AngularTutorialAgendaApp/deployments",
    "created_at": "2019-09-22T12:40:37Z",
    "updated_at": "2019-10-04T05:37:42Z",
    "pushed_at": "2020-09-10T13:46:43Z",
    "git_url": "git://github.com/girishgodage/AngularTutorialAgendaApp.git",
    "ssh_url": "git@github.com:girishgodage/AngularTutorialAgendaApp.git",
    "clone_url": "https://github.com/girishgodage/AngularTutorialAgendaApp.git",
    "svn_url": "https://github.com/girishgodage/AngularTutorialAgendaApp",
    "homepage": null,
    "size": 1593,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 11,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 11,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 207709806,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDc3MDk4MDY=",
    "name": "article-resources",
    "full_name": "girishgodage/article-resources",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/article-resources",
    "description": "A repository for the source code, notebooks, data, files, and other assets used in the data science and machine learning articles on LearnDataSci",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/article-resources",
    "forks_url": "https://api.github.com/repos/girishgodage/article-resources/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/article-resources/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/article-resources/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/article-resources/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/article-resources/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/article-resources/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/article-resources/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/article-resources/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/article-resources/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/article-resources/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/article-resources/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/article-resources/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/article-resources/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/article-resources/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/article-resources/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/article-resources/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/article-resources/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/article-resources/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/article-resources/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/article-resources/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/article-resources/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/article-resources/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/article-resources/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/article-resources/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/article-resources/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/article-resources/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/article-resources/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/article-resources/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/article-resources/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/article-resources/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/article-resources/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/article-resources/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/article-resources/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/article-resources/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/article-resources/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/article-resources/deployments",
    "created_at": "2019-09-11T02:54:48Z",
    "updated_at": "2019-09-11T02:54:49Z",
    "pushed_at": "2019-01-02T13:28:32Z",
    "git_url": "git://github.com/girishgodage/article-resources.git",
    "ssh_url": "git@github.com:girishgodage/article-resources.git",
    "clone_url": "https://github.com/girishgodage/article-resources.git",
    "svn_url": "https://github.com/girishgodage/article-resources",
    "homepage": "https://www.learndatasci.com",
    "size": 40195,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224435128,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzUxMjg=",
    "name": "ASP.NET-Core-2-jQuery-Ajax-Modal-Form",
    "full_name": "girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form",
    "description": "Asp.Net Example Implementation of Modal Form using Asp.Net Core 2 Mvc JQuery Ajax Bootstrap Modal Form",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form",
    "forks_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form/deployments",
    "created_at": "2019-11-27T13:17:07Z",
    "updated_at": "2019-11-27T13:17:09Z",
    "pushed_at": "2019-02-13T14:13:28Z",
    "git_url": "git://github.com/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form.git",
    "ssh_url": "git@github.com:girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form.git",
    "clone_url": "https://github.com/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form.git",
    "svn_url": "https://github.com/girishgodage/ASP.NET-Core-2-jQuery-Ajax-Modal-Form",
    "homepage": "",
    "size": 768,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224431314,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzEzMTQ=",
    "name": "ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin",
    "full_name": "girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin",
    "description": "Asp.Net Example implementation of datatables.net using Asp.Net Core 2 Mvc CRUD datatables jQuery Plugin",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin",
    "forks_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin/deployments",
    "created_at": "2019-11-27T12:56:28Z",
    "updated_at": "2019-11-27T12:56:30Z",
    "pushed_at": "2019-02-13T14:06:34Z",
    "git_url": "git://github.com/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin.git",
    "ssh_url": "git@github.com:girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin.git",
    "clone_url": "https://github.com/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin.git",
    "svn_url": "https://github.com/girishgodage/ASP.NET-Core-2-MVC-CRUD-datatables-jQuery-Plugin",
    "homepage": "",
    "size": 2064,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224435748,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzU3NDg=",
    "name": "Asp.Net-Core-Free-Theme-Landing-Page",
    "full_name": "girishgodage/Asp.Net-Core-Free-Theme-Landing-Page",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page",
    "description": "Ready to use beautiful landing page based on Asp.Net Core 2.2",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page",
    "forks_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page/deployments",
    "created_at": "2019-11-27T13:20:16Z",
    "updated_at": "2019-11-27T13:20:18Z",
    "pushed_at": "2019-02-13T14:09:56Z",
    "git_url": "git://github.com/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page.git",
    "ssh_url": "git@github.com:girishgodage/Asp.Net-Core-Free-Theme-Landing-Page.git",
    "clone_url": "https://github.com/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page.git",
    "svn_url": "https://github.com/girishgodage/Asp.Net-Core-Free-Theme-Landing-Page",
    "homepage": "https://landing-page-lite.azurewebsites.net/Apps",
    "size": 4993,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224435394,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzUzOTQ=",
    "name": "Asp.Net-User-Role-Membership-Example",
    "full_name": "girishgodage/Asp.Net-User-Role-Membership-Example",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Asp.Net-User-Role-Membership-Example",
    "description": "Asp.Net Core Mvc Full Implementation Example of User Role & Membership.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example",
    "forks_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Asp.Net-User-Role-Membership-Example/deployments",
    "created_at": "2019-11-27T13:18:31Z",
    "updated_at": "2019-11-27T13:18:33Z",
    "pushed_at": "2019-02-13T14:11:34Z",
    "git_url": "git://github.com/girishgodage/Asp.Net-User-Role-Membership-Example.git",
    "ssh_url": "git@github.com:girishgodage/Asp.Net-User-Role-Membership-Example.git",
    "clone_url": "https://github.com/girishgodage/Asp.Net-User-Role-Membership-Example.git",
    "svn_url": "https://github.com/girishgodage/Asp.Net-User-Role-Membership-Example",
    "homepage": null,
    "size": 67249,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 295975572,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTU5NzU1NzI=",
    "name": "aspnetboilerplate",
    "full_name": "girishgodage/aspnetboilerplate",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/aspnetboilerplate",
    "description": "ASP.NET Boilerplate - Web Application Framework",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/aspnetboilerplate",
    "forks_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/aspnetboilerplate/deployments",
    "created_at": "2020-09-16T08:45:18Z",
    "updated_at": "2020-09-16T08:45:21Z",
    "pushed_at": "2020-09-15T07:39:00Z",
    "git_url": "git://github.com/girishgodage/aspnetboilerplate.git",
    "ssh_url": "git@github.com:girishgodage/aspnetboilerplate.git",
    "clone_url": "https://github.com/girishgodage/aspnetboilerplate.git",
    "svn_url": "https://github.com/girishgodage/aspnetboilerplate",
    "homepage": "https://aspnetboilerplate.com",
    "size": 60658,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "dev"
  },
  {
    "id": 196189179,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTYxODkxNzk=",
    "name": "ASPNETCoreDockerMicroservices",
    "full_name": "girishgodage/ASPNETCoreDockerMicroservices",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/ASPNETCoreDockerMicroservices",
    "description": "Sample project for getting off the ground with ASP.NET Core, Docker and Microservices based on the tutorial: https://fullstackmark.com/post/12/get-started-building-microservices-with-asp.net-core-and-docker-in-visual-studio-code",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices",
    "forks_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/ASPNETCoreDockerMicroservices/deployments",
    "created_at": "2019-07-10T11:02:34Z",
    "updated_at": "2019-07-10T11:02:36Z",
    "pushed_at": "2017-12-28T15:15:01Z",
    "git_url": "git://github.com/girishgodage/ASPNETCoreDockerMicroservices.git",
    "ssh_url": "git@github.com:girishgodage/ASPNETCoreDockerMicroservices.git",
    "clone_url": "https://github.com/girishgodage/ASPNETCoreDockerMicroservices.git",
    "svn_url": "https://github.com/girishgodage/ASPNETCoreDockerMicroservices",
    "homepage": "",
    "size": 685,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 251075482,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTEwNzU0ODI=",
    "name": "awesome-aws",
    "full_name": "girishgodage/awesome-aws",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/awesome-aws",
    "description": "A curated list of awesome Amazon Web Services (AWS) libraries, open source repos, guides, blogs, and other resources.  Featuring the Fiery Meter of AWSome.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/awesome-aws",
    "forks_url": "https://api.github.com/repos/girishgodage/awesome-aws/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/awesome-aws/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/awesome-aws/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/awesome-aws/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/awesome-aws/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/awesome-aws/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/awesome-aws/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/awesome-aws/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/awesome-aws/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/awesome-aws/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/awesome-aws/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/awesome-aws/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/awesome-aws/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/awesome-aws/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/awesome-aws/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/awesome-aws/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/awesome-aws/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/awesome-aws/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/awesome-aws/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/awesome-aws/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/awesome-aws/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/awesome-aws/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/awesome-aws/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/awesome-aws/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/awesome-aws/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/awesome-aws/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/awesome-aws/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/awesome-aws/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/awesome-aws/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/awesome-aws/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/awesome-aws/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/awesome-aws/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/awesome-aws/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/awesome-aws/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/awesome-aws/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/awesome-aws/deployments",
    "created_at": "2020-03-29T16:14:26Z",
    "updated_at": "2020-03-29T16:14:28Z",
    "pushed_at": "2020-03-24T03:12:15Z",
    "git_url": "git://github.com/girishgodage/awesome-aws.git",
    "ssh_url": "git@github.com:girishgodage/awesome-aws.git",
    "clone_url": "https://github.com/girishgodage/awesome-aws.git",
    "svn_url": "https://github.com/girishgodage/awesome-aws",
    "homepage": "",
    "size": 782,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 226781421,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjY3ODE0MjE=",
    "name": "awesome-blazor",
    "full_name": "girishgodage/awesome-blazor",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/awesome-blazor",
    "description": "Resources for Blazor, a .NET web framework using C#/Razor and HTML that runs in the browser with WebAssembly.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/awesome-blazor",
    "forks_url": "https://api.github.com/repos/girishgodage/awesome-blazor/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/awesome-blazor/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/awesome-blazor/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/awesome-blazor/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/awesome-blazor/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/awesome-blazor/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/awesome-blazor/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/awesome-blazor/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/awesome-blazor/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/awesome-blazor/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/awesome-blazor/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/awesome-blazor/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/awesome-blazor/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/awesome-blazor/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/awesome-blazor/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/awesome-blazor/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/awesome-blazor/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/awesome-blazor/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/awesome-blazor/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/awesome-blazor/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/awesome-blazor/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/awesome-blazor/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/awesome-blazor/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/awesome-blazor/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/awesome-blazor/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/awesome-blazor/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/awesome-blazor/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/awesome-blazor/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/awesome-blazor/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/awesome-blazor/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/awesome-blazor/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/awesome-blazor/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/awesome-blazor/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/awesome-blazor/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/awesome-blazor/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/awesome-blazor/deployments",
    "created_at": "2019-12-09T04:02:15Z",
    "updated_at": "2020-09-24T05:24:20Z",
    "pushed_at": "2020-09-24T05:23:06Z",
    "git_url": "git://github.com/girishgodage/awesome-blazor.git",
    "ssh_url": "git@github.com:girishgodage/awesome-blazor.git",
    "clone_url": "https://github.com/girishgodage/awesome-blazor.git",
    "svn_url": "https://github.com/girishgodage/awesome-blazor",
    "homepage": "",
    "size": 4253,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "cc0-1.0",
      "name": "Creative Commons Zero v1.0 Universal",
      "spdx_id": "CC0-1.0",
      "url": "https://api.github.com/licenses/cc0-1.0",
      "node_id": "MDc6TGljZW5zZTY="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 229690674,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjk2OTA2NzQ=",
    "name": "awesome-dotnet-core",
    "full_name": "girishgodage/awesome-dotnet-core",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/awesome-dotnet-core",
    "description": ":honeybee: A collection of awesome .NET core libraries, tools, frameworks and software",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core",
    "forks_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/awesome-dotnet-core/deployments",
    "created_at": "2019-12-23T06:27:23Z",
    "updated_at": "2019-12-23T06:27:25Z",
    "pushed_at": "2019-12-18T14:49:53Z",
    "git_url": "git://github.com/girishgodage/awesome-dotnet-core.git",
    "ssh_url": "git@github.com:girishgodage/awesome-dotnet-core.git",
    "clone_url": "https://github.com/girishgodage/awesome-dotnet-core.git",
    "svn_url": "https://github.com/girishgodage/awesome-dotnet-core",
    "homepage": "",
    "size": 1402,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 207500415,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDc1MDA0MTU=",
    "name": "awesome-machine-learning",
    "full_name": "girishgodage/awesome-machine-learning",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/awesome-machine-learning",
    "description": "A curated list of awesome Machine Learning frameworks, libraries and software.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/awesome-machine-learning",
    "forks_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/awesome-machine-learning/deployments",
    "created_at": "2019-09-10T08:05:57Z",
    "updated_at": "2019-09-10T08:05:58Z",
    "pushed_at": "2019-09-09T13:57:19Z",
    "git_url": "git://github.com/girishgodage/awesome-machine-learning.git",
    "ssh_url": "git@github.com:girishgodage/awesome-machine-learning.git",
    "clone_url": "https://github.com/girishgodage/awesome-machine-learning.git",
    "svn_url": "https://github.com/girishgodage/awesome-machine-learning",
    "homepage": null,
    "size": 1956,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 144679662,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDQ2Nzk2NjI=",
    "name": "awesome-microservices",
    "full_name": "girishgodage/awesome-microservices",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/awesome-microservices",
    "description": "A curated list of Microservice Architecture related principles and technologies.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/awesome-microservices",
    "forks_url": "https://api.github.com/repos/girishgodage/awesome-microservices/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/awesome-microservices/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/awesome-microservices/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/awesome-microservices/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/awesome-microservices/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/awesome-microservices/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/awesome-microservices/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/awesome-microservices/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/awesome-microservices/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/awesome-microservices/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/awesome-microservices/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/awesome-microservices/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/awesome-microservices/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/awesome-microservices/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/awesome-microservices/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/awesome-microservices/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/awesome-microservices/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/awesome-microservices/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/awesome-microservices/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/awesome-microservices/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/awesome-microservices/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/awesome-microservices/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/awesome-microservices/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/awesome-microservices/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/awesome-microservices/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/awesome-microservices/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/awesome-microservices/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/awesome-microservices/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/awesome-microservices/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/awesome-microservices/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/awesome-microservices/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/awesome-microservices/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/awesome-microservices/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/awesome-microservices/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/awesome-microservices/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/awesome-microservices/deployments",
    "created_at": "2018-08-14T06:42:55Z",
    "updated_at": "2018-08-14T06:42:57Z",
    "pushed_at": "2018-07-16T20:53:32Z",
    "git_url": "git://github.com/girishgodage/awesome-microservices.git",
    "ssh_url": "git@github.com:girishgodage/awesome-microservices.git",
    "clone_url": "https://github.com/girishgodage/awesome-microservices.git",
    "svn_url": "https://github.com/girishgodage/awesome-microservices",
    "homepage": null,
    "size": 1114,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "cc0-1.0",
      "name": "Creative Commons Zero v1.0 Universal",
      "spdx_id": "CC0-1.0",
      "url": "https://api.github.com/licenses/cc0-1.0",
      "node_id": "MDc6TGljZW5zZTY="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 207500502,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDc1MDA1MDI=",
    "name": "awesome-public-datasets",
    "full_name": "girishgodage/awesome-public-datasets",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/awesome-public-datasets",
    "description": "A topic-centric list of HQ open datasets. PR ☛☛☛",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/awesome-public-datasets",
    "forks_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/awesome-public-datasets/deployments",
    "created_at": "2019-09-10T08:06:19Z",
    "updated_at": "2019-09-10T08:06:20Z",
    "pushed_at": "2019-08-14T07:47:27Z",
    "git_url": "git://github.com/girishgodage/awesome-public-datasets.git",
    "ssh_url": "git@github.com:girishgodage/awesome-public-datasets.git",
    "clone_url": "https://github.com/girishgodage/awesome-public-datasets.git",
    "svn_url": "https://github.com/girishgodage/awesome-public-datasets",
    "homepage": "https://github.com/awesomedata/apd-core",
    "size": 655,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 251075951,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTEwNzU5NTE=",
    "name": "aws-lambda-blog",
    "full_name": "girishgodage/aws-lambda-blog",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/aws-lambda-blog",
    "description": "AWS Lambda serverless blogging platform ",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/aws-lambda-blog",
    "forks_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/aws-lambda-blog/deployments",
    "created_at": "2020-03-29T16:16:43Z",
    "updated_at": "2020-03-29T16:16:45Z",
    "pushed_at": "2018-09-01T14:40:26Z",
    "git_url": "git://github.com/girishgodage/aws-lambda-blog.git",
    "ssh_url": "git@github.com:girishgodage/aws-lambda-blog.git",
    "clone_url": "https://github.com/girishgodage/aws-lambda-blog.git",
    "svn_url": "https://github.com/girishgodage/aws-lambda-blog",
    "homepage": "",
    "size": 7390,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 239651579,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzk2NTE1Nzk=",
    "name": "aws-lambda-dotnet",
    "full_name": "girishgodage/aws-lambda-dotnet",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/aws-lambda-dotnet",
    "description": "Libraries, samples and tools to help .NET Core developers develop AWS Lambda functions.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet",
    "forks_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/aws-lambda-dotnet/deployments",
    "created_at": "2020-02-11T01:37:44Z",
    "updated_at": "2020-02-11T01:37:46Z",
    "pushed_at": "2020-02-10T22:20:00Z",
    "git_url": "git://github.com/girishgodage/aws-lambda-dotnet.git",
    "ssh_url": "git@github.com:girishgodage/aws-lambda-dotnet.git",
    "clone_url": "https://github.com/girishgodage/aws-lambda-dotnet.git",
    "svn_url": "https://github.com/girishgodage/aws-lambda-dotnet",
    "homepage": null,
    "size": 20843,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "apache-2.0",
      "name": "Apache License 2.0",
      "spdx_id": "Apache-2.0",
      "url": "https://api.github.com/licenses/apache-2.0",
      "node_id": "MDc6TGljZW5zZTI="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 238147624,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzgxNDc2MjQ=",
    "name": "aws-nlp-workshop",
    "full_name": "girishgodage/aws-nlp-workshop",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/aws-nlp-workshop",
    "description": "Natural Language Processing on AWS Workshop",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop",
    "forks_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/aws-nlp-workshop/deployments",
    "created_at": "2020-02-04T07:26:12Z",
    "updated_at": "2020-02-04T07:26:13Z",
    "pushed_at": "2019-01-28T20:52:57Z",
    "git_url": "git://github.com/girishgodage/aws-nlp-workshop.git",
    "ssh_url": "git@github.com:girishgodage/aws-nlp-workshop.git",
    "clone_url": "https://github.com/girishgodage/aws-nlp-workshop.git",
    "svn_url": "https://github.com/girishgodage/aws-nlp-workshop",
    "homepage": "",
    "size": 45446,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 238148018,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzgxNDgwMTg=",
    "name": "aws-open-data-analytics-notebooks",
    "full_name": "girishgodage/aws-open-data-analytics-notebooks",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/aws-open-data-analytics-notebooks",
    "description": "AWS analytics, AI, and data science service abstractions API and samples built using Amazon SageMaker notebooks",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks",
    "forks_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/aws-open-data-analytics-notebooks/deployments",
    "created_at": "2020-02-04T07:28:39Z",
    "updated_at": "2020-02-04T07:28:41Z",
    "pushed_at": "2019-10-19T16:10:18Z",
    "git_url": "git://github.com/girishgodage/aws-open-data-analytics-notebooks.git",
    "ssh_url": "git@github.com:girishgodage/aws-open-data-analytics-notebooks.git",
    "clone_url": "https://github.com/girishgodage/aws-open-data-analytics-notebooks.git",
    "svn_url": "https://github.com/girishgodage/aws-open-data-analytics-notebooks",
    "homepage": "",
    "size": 8057,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "apache-2.0",
      "name": "Apache License 2.0",
      "spdx_id": "Apache-2.0",
      "url": "https://api.github.com/licenses/apache-2.0",
      "node_id": "MDc6TGljZW5zZTI="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 240180454,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDAxODA0NTQ=",
    "name": "aws-serverless-workshops",
    "full_name": "girishgodage/aws-serverless-workshops",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/aws-serverless-workshops",
    "description": "Code and walkthrough labs to set up serverless applications for Wild Rydes workshops",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops",
    "forks_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/aws-serverless-workshops/deployments",
    "created_at": "2020-02-13T04:56:52Z",
    "updated_at": "2020-02-13T04:56:54Z",
    "pushed_at": "2020-02-11T00:21:55Z",
    "git_url": "git://github.com/girishgodage/aws-serverless-workshops.git",
    "ssh_url": "git@github.com:girishgodage/aws-serverless-workshops.git",
    "clone_url": "https://github.com/girishgodage/aws-serverless-workshops.git",
    "svn_url": "https://github.com/girishgodage/aws-serverless-workshops",
    "homepage": "http://wildrydes.com",
    "size": 163241,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "apache-2.0",
      "name": "Apache License 2.0",
      "spdx_id": "Apache-2.0",
      "url": "https://api.github.com/licenses/apache-2.0",
      "node_id": "MDc6TGljZW5zZTI="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 66648957,
    "node_id": "MDEwOlJlcG9zaXRvcnk2NjY0ODk1Nw==",
    "name": "azure-content",
    "full_name": "girishgodage/azure-content",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/azure-content",
    "description": "Repository containing the Articles on azure.microsoft.com Documentation Center",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/azure-content",
    "forks_url": "https://api.github.com/repos/girishgodage/azure-content/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/azure-content/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/azure-content/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/azure-content/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/azure-content/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/azure-content/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/azure-content/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/azure-content/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/azure-content/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/azure-content/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/azure-content/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/azure-content/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/azure-content/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/azure-content/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/azure-content/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/azure-content/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/azure-content/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/azure-content/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/azure-content/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/azure-content/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/azure-content/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/azure-content/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/azure-content/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/azure-content/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/azure-content/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/azure-content/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/azure-content/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/azure-content/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/azure-content/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/azure-content/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/azure-content/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/azure-content/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/azure-content/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/azure-content/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/azure-content/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/azure-content/deployments",
    "created_at": "2016-08-26T13:13:40Z",
    "updated_at": "2016-08-26T13:14:38Z",
    "pushed_at": "2016-08-26T12:11:22Z",
    "git_url": "git://github.com/girishgodage/azure-content.git",
    "ssh_url": "git@github.com:girishgodage/azure-content.git",
    "clone_url": "https://github.com/girishgodage/azure-content.git",
    "svn_url": "https://github.com/girishgodage/azure-content",
    "homepage": "",
    "size": 2102801,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "GCC Machine Description",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 250541681,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTA1NDE2ODE=",
    "name": "azure-docs",
    "full_name": "girishgodage/azure-docs",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/azure-docs",
    "description": "Open source documentation of Microsoft Azure",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/azure-docs",
    "forks_url": "https://api.github.com/repos/girishgodage/azure-docs/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/azure-docs/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/azure-docs/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/azure-docs/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/azure-docs/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/azure-docs/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/azure-docs/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/azure-docs/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/azure-docs/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/azure-docs/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/azure-docs/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/azure-docs/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/azure-docs/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/azure-docs/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/azure-docs/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/azure-docs/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/azure-docs/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/azure-docs/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/azure-docs/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/azure-docs/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/azure-docs/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/azure-docs/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/azure-docs/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/azure-docs/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/azure-docs/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/azure-docs/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/azure-docs/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/azure-docs/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/azure-docs/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/azure-docs/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/azure-docs/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/azure-docs/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/azure-docs/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/azure-docs/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/azure-docs/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/azure-docs/deployments",
    "created_at": "2020-03-27T13:28:45Z",
    "updated_at": "2020-03-27T13:28:49Z",
    "pushed_at": "2020-03-27T13:17:35Z",
    "git_url": "git://github.com/girishgodage/azure-docs.git",
    "ssh_url": "git@github.com:girishgodage/azure-docs.git",
    "clone_url": "https://github.com/girishgodage/azure-docs.git",
    "svn_url": "https://github.com/girishgodage/azure-docs",
    "homepage": "https://docs.microsoft.com/azure",
    "size": 9687475,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 321914648,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjE5MTQ2NDg=",
    "name": "azure-serverless-with-blazor",
    "full_name": "girishgodage/azure-serverless-with-blazor",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/azure-serverless-with-blazor",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor",
    "forks_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/azure-serverless-with-blazor/deployments",
    "created_at": "2020-12-16T08:17:15Z",
    "updated_at": "2021-01-19T09:51:39Z",
    "pushed_at": "2020-12-16T08:52:30Z",
    "git_url": "git://github.com/girishgodage/azure-serverless-with-blazor.git",
    "ssh_url": "git@github.com:girishgodage/azure-serverless-with-blazor.git",
    "clone_url": "https://github.com/girishgodage/azure-serverless-with-blazor.git",
    "svn_url": "https://github.com/girishgodage/azure-serverless-with-blazor",
    "homepage": null,
    "size": 15366,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 334381021,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMzQzODEwMjE=",
    "name": "BeachResortApp",
    "full_name": "girishgodage/BeachResortApp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/BeachResortApp",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/BeachResortApp",
    "forks_url": "https://api.github.com/repos/girishgodage/BeachResortApp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/BeachResortApp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/BeachResortApp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/BeachResortApp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/BeachResortApp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/BeachResortApp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/BeachResortApp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/BeachResortApp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/BeachResortApp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/BeachResortApp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/BeachResortApp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/BeachResortApp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/BeachResortApp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/BeachResortApp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/BeachResortApp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/BeachResortApp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/BeachResortApp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/BeachResortApp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/BeachResortApp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/BeachResortApp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/BeachResortApp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/BeachResortApp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/BeachResortApp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/BeachResortApp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/BeachResortApp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/BeachResortApp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/BeachResortApp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/BeachResortApp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/BeachResortApp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/BeachResortApp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/BeachResortApp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/BeachResortApp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/BeachResortApp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/BeachResortApp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/BeachResortApp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/BeachResortApp/deployments",
    "created_at": "2021-01-30T10:01:56Z",
    "updated_at": "2021-01-30T10:54:19Z",
    "pushed_at": "2021-01-30T10:54:17Z",
    "git_url": "git://github.com/girishgodage/BeachResortApp.git",
    "ssh_url": "git@github.com:girishgodage/BeachResortApp.git",
    "clone_url": "https://github.com/girishgodage/BeachResortApp.git",
    "svn_url": "https://github.com/girishgodage/BeachResortApp",
    "homepage": null,
    "size": 2459,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 297271978,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTcyNzE5Nzg=",
    "name": "BlazingChat",
    "full_name": "girishgodage/BlazingChat",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/BlazingChat",
    "description": "This is a blazor webassmbly chat app using SignalR",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/BlazingChat",
    "forks_url": "https://api.github.com/repos/girishgodage/BlazingChat/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/BlazingChat/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/BlazingChat/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/BlazingChat/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/BlazingChat/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/BlazingChat/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/BlazingChat/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/BlazingChat/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/BlazingChat/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/BlazingChat/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/BlazingChat/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/BlazingChat/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/BlazingChat/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/BlazingChat/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/BlazingChat/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/BlazingChat/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/BlazingChat/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/BlazingChat/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/BlazingChat/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/BlazingChat/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/BlazingChat/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/BlazingChat/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/BlazingChat/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/BlazingChat/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/BlazingChat/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/BlazingChat/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/BlazingChat/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/BlazingChat/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/BlazingChat/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/BlazingChat/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/BlazingChat/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/BlazingChat/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/BlazingChat/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/BlazingChat/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/BlazingChat/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/BlazingChat/deployments",
    "created_at": "2020-09-21T08:11:23Z",
    "updated_at": "2020-09-21T08:11:25Z",
    "pushed_at": "2020-09-02T18:02:29Z",
    "git_url": "git://github.com/girishgodage/BlazingChat.git",
    "ssh_url": "git@github.com:girishgodage/BlazingChat.git",
    "clone_url": "https://github.com/girishgodage/BlazingChat.git",
    "svn_url": "https://github.com/girishgodage/BlazingChat",
    "homepage": null,
    "size": 18341,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 322658926,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjI2NTg5MjY=",
    "name": "Blazor-Translator-Azure-Cognitive-Services",
    "full_name": "girishgodage/Blazor-Translator-Azure-Cognitive-Services",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Blazor-Translator-Azure-Cognitive-Services",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services",
    "forks_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Blazor-Translator-Azure-Cognitive-Services/deployments",
    "created_at": "2020-12-18T17:16:19Z",
    "updated_at": "2021-01-19T09:51:25Z",
    "pushed_at": "2020-12-18T17:47:57Z",
    "git_url": "git://github.com/girishgodage/Blazor-Translator-Azure-Cognitive-Services.git",
    "ssh_url": "git@github.com:girishgodage/Blazor-Translator-Azure-Cognitive-Services.git",
    "clone_url": "https://github.com/girishgodage/Blazor-Translator-Azure-Cognitive-Services.git",
    "svn_url": "https://github.com/girishgodage/Blazor-Translator-Azure-Cognitive-Services",
    "homepage": null,
    "size": 917,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 211649095,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTE2NDkwOTU=",
    "name": "blazor-workshop",
    "full_name": "girishgodage/blazor-workshop",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/blazor-workshop",
    "description": "Blazor workshop",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/blazor-workshop",
    "forks_url": "https://api.github.com/repos/girishgodage/blazor-workshop/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/blazor-workshop/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/blazor-workshop/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/blazor-workshop/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/blazor-workshop/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/blazor-workshop/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/blazor-workshop/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/blazor-workshop/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/blazor-workshop/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/blazor-workshop/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/blazor-workshop/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/blazor-workshop/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/blazor-workshop/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/blazor-workshop/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/blazor-workshop/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/blazor-workshop/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/blazor-workshop/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/blazor-workshop/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/blazor-workshop/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/blazor-workshop/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/blazor-workshop/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/blazor-workshop/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/blazor-workshop/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/blazor-workshop/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/blazor-workshop/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/blazor-workshop/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/blazor-workshop/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/blazor-workshop/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/blazor-workshop/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/blazor-workshop/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/blazor-workshop/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/blazor-workshop/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/blazor-workshop/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/blazor-workshop/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/blazor-workshop/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/blazor-workshop/deployments",
    "created_at": "2019-09-29T10:58:22Z",
    "updated_at": "2019-09-29T10:58:24Z",
    "pushed_at": "2019-07-30T11:29:20Z",
    "git_url": "git://github.com/girishgodage/blazor-workshop.git",
    "ssh_url": "git@github.com:girishgodage/blazor-workshop.git",
    "clone_url": "https://github.com/girishgodage/blazor-workshop.git",
    "svn_url": "https://github.com/girishgodage/blazor-workshop",
    "homepage": "",
    "size": 2155,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 290382887,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTAzODI4ODc=",
    "name": "blazorboilerplate",
    "full_name": "girishgodage/blazorboilerplate",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/blazorboilerplate",
    "description": "Blazor Boilerplate / Starter Template with MatBlazor ",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/blazorboilerplate",
    "forks_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/blazorboilerplate/deployments",
    "created_at": "2020-08-26T03:14:41Z",
    "updated_at": "2020-08-26T03:14:42Z",
    "pushed_at": "2020-08-23T20:12:19Z",
    "git_url": "git://github.com/girishgodage/blazorboilerplate.git",
    "ssh_url": "git@github.com:girishgodage/blazorboilerplate.git",
    "clone_url": "https://github.com/girishgodage/blazorboilerplate.git",
    "svn_url": "https://github.com/girishgodage/blazorboilerplate",
    "homepage": null,
    "size": 5759,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 291895995,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTE4OTU5OTU=",
    "name": "BlazorCalendar",
    "full_name": "girishgodage/BlazorCalendar",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/BlazorCalendar",
    "description": "Blazor Outlook Calendar is the a Blazor WebAssembly Client-Side application to manage your events synced with Microsoft Outlook Calendar using Microsoft Graph API",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/BlazorCalendar",
    "forks_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/BlazorCalendar/deployments",
    "created_at": "2020-09-01T04:30:40Z",
    "updated_at": "2020-09-01T06:09:53Z",
    "pushed_at": "2020-09-01T06:09:51Z",
    "git_url": "git://github.com/girishgodage/BlazorCalendar.git",
    "ssh_url": "git@github.com:girishgodage/BlazorCalendar.git",
    "clone_url": "https://github.com/girishgodage/BlazorCalendar.git",
    "svn_url": "https://github.com/girishgodage/BlazorCalendar",
    "homepage": null,
    "size": 14252,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 322532117,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjI1MzIxMTc=",
    "name": "BlazorComputerVisionAzureCognitiveServices",
    "full_name": "girishgodage/BlazorComputerVisionAzureCognitiveServices",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/BlazorComputerVisionAzureCognitiveServices",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices",
    "forks_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/BlazorComputerVisionAzureCognitiveServices/deployments",
    "created_at": "2020-12-18T08:16:34Z",
    "updated_at": "2020-12-18T10:06:40Z",
    "pushed_at": "2020-12-18T10:06:38Z",
    "git_url": "git://github.com/girishgodage/BlazorComputerVisionAzureCognitiveServices.git",
    "ssh_url": "git@github.com:girishgodage/BlazorComputerVisionAzureCognitiveServices.git",
    "clone_url": "https://github.com/girishgodage/BlazorComputerVisionAzureCognitiveServices.git",
    "svn_url": "https://github.com/girishgodage/BlazorComputerVisionAzureCognitiveServices",
    "homepage": null,
    "size": 64895,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 291899395,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTE4OTkzOTU=",
    "name": "BlazorOutlookCalendar",
    "full_name": "girishgodage/BlazorOutlookCalendar",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/BlazorOutlookCalendar",
    "description": "Blazor Outlook Calendar is the a Blazor WebAssembly Client-Side application to manage your events synced with Microsoft Outlook Calendar using Microsoft Graph API",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar",
    "forks_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/BlazorOutlookCalendar/deployments",
    "created_at": "2020-09-01T04:52:59Z",
    "updated_at": "2020-09-01T04:53:01Z",
    "pushed_at": "2020-05-27T05:47:31Z",
    "git_url": "git://github.com/girishgodage/BlazorOutlookCalendar.git",
    "ssh_url": "git@github.com:girishgodage/BlazorOutlookCalendar.git",
    "clone_url": "https://github.com/girishgodage/BlazorOutlookCalendar.git",
    "svn_url": "https://github.com/girishgodage/BlazorOutlookCalendar",
    "homepage": null,
    "size": 516,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 292331374,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTIzMzEzNzQ=",
    "name": "BlazorTable",
    "full_name": "girishgodage/BlazorTable",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/BlazorTable",
    "description": "Blazor Table Component with Sorting, Paging and Filtering",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/BlazorTable",
    "forks_url": "https://api.github.com/repos/girishgodage/BlazorTable/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/BlazorTable/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/BlazorTable/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/BlazorTable/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/BlazorTable/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/BlazorTable/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/BlazorTable/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/BlazorTable/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/BlazorTable/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/BlazorTable/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/BlazorTable/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/BlazorTable/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/BlazorTable/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/BlazorTable/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/BlazorTable/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/BlazorTable/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/BlazorTable/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/BlazorTable/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/BlazorTable/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/BlazorTable/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/BlazorTable/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/BlazorTable/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/BlazorTable/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/BlazorTable/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/BlazorTable/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/BlazorTable/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/BlazorTable/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/BlazorTable/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/BlazorTable/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/BlazorTable/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/BlazorTable/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/BlazorTable/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/BlazorTable/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/BlazorTable/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/BlazorTable/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/BlazorTable/deployments",
    "created_at": "2020-09-02T16:09:17Z",
    "updated_at": "2020-09-02T16:09:18Z",
    "pushed_at": "2020-08-26T20:39:53Z",
    "git_url": "git://github.com/girishgodage/BlazorTable.git",
    "ssh_url": "git@github.com:girishgodage/BlazorTable.git",
    "clone_url": "https://github.com/girishgodage/BlazorTable.git",
    "svn_url": "https://github.com/girishgodage/BlazorTable",
    "homepage": "https://BlazorTable.netlify.app",
    "size": 1374,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 293518583,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTM1MTg1ODM=",
    "name": "blazorwithSignalR",
    "full_name": "girishgodage/blazorwithSignalR",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/blazorwithSignalR",
    "description": "Blazor Webassembly with SignalR to implement real-time feature in your Blazor Client-Side apps",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/blazorwithSignalR",
    "forks_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/blazorwithSignalR/deployments",
    "created_at": "2020-09-07T12:13:32Z",
    "updated_at": "2020-09-07T12:22:55Z",
    "pushed_at": "2020-09-07T12:22:51Z",
    "git_url": "git://github.com/girishgodage/blazorwithSignalR.git",
    "ssh_url": "git@github.com:girishgodage/blazorwithSignalR.git",
    "clone_url": "https://github.com/girishgodage/blazorwithSignalR.git",
    "svn_url": "https://github.com/girishgodage/blazorwithSignalR",
    "homepage": null,
    "size": 15274,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 191613791,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTE2MTM3OTE=",
    "name": "blog",
    "full_name": "girishgodage/blog",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/blog",
    "description": "An open source,simple Blog developed with Angular 7, .Net Core and Mongo Db",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/blog",
    "forks_url": "https://api.github.com/repos/girishgodage/blog/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/blog/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/blog/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/blog/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/blog/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/blog/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/blog/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/blog/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/blog/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/blog/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/blog/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/blog/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/blog/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/blog/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/blog/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/blog/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/blog/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/blog/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/blog/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/blog/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/blog/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/blog/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/blog/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/blog/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/blog/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/blog/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/blog/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/blog/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/blog/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/blog/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/blog/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/blog/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/blog/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/blog/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/blog/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/blog/deployments",
    "created_at": "2019-06-12T17:11:45Z",
    "updated_at": "2019-06-13T11:33:18Z",
    "pushed_at": "2020-09-09T07:17:09Z",
    "git_url": "git://github.com/girishgodage/blog.git",
    "ssh_url": "git@github.com:girishgodage/blog.git",
    "clone_url": "https://github.com/girishgodage/blog.git",
    "svn_url": "https://github.com/girishgodage/blog",
    "homepage": null,
    "size": 842,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 9,
    "license": null,
    "forks": 0,
    "open_issues": 9,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 200363611,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDAzNjM2MTE=",
    "name": "books",
    "full_name": "girishgodage/books",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/books",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/books",
    "forks_url": "https://api.github.com/repos/girishgodage/books/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/books/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/books/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/books/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/books/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/books/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/books/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/books/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/books/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/books/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/books/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/books/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/books/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/books/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/books/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/books/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/books/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/books/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/books/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/books/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/books/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/books/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/books/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/books/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/books/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/books/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/books/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/books/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/books/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/books/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/books/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/books/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/books/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/books/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/books/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/books/deployments",
    "created_at": "2019-08-03T10:41:59Z",
    "updated_at": "2020-05-08T18:44:55Z",
    "pushed_at": "2019-07-09T13:03:34Z",
    "git_url": "git://github.com/girishgodage/books.git",
    "ssh_url": "git@github.com:girishgodage/books.git",
    "clone_url": "https://github.com/girishgodage/books.git",
    "svn_url": "https://github.com/girishgodage/books",
    "homepage": null,
    "size": 357486,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 213041237,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTMwNDEyMzc=",
    "name": "books-1",
    "full_name": "girishgodage/books-1",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/books-1",
    "description": "book list",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/books-1",
    "forks_url": "https://api.github.com/repos/girishgodage/books-1/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/books-1/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/books-1/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/books-1/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/books-1/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/books-1/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/books-1/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/books-1/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/books-1/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/books-1/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/books-1/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/books-1/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/books-1/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/books-1/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/books-1/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/books-1/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/books-1/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/books-1/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/books-1/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/books-1/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/books-1/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/books-1/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/books-1/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/books-1/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/books-1/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/books-1/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/books-1/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/books-1/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/books-1/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/books-1/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/books-1/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/books-1/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/books-1/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/books-1/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/books-1/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/books-1/deployments",
    "created_at": "2019-10-05T17:24:26Z",
    "updated_at": "2019-10-05T17:24:27Z",
    "pushed_at": "2019-03-04T01:47:37Z",
    "git_url": "git://github.com/girishgodage/books-1.git",
    "ssh_url": "git@github.com:girishgodage/books-1.git",
    "clone_url": "https://github.com/girishgodage/books-1.git",
    "svn_url": "https://github.com/girishgodage/books-1",
    "homepage": null,
    "size": 317930,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 140072105,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDAwNzIxMDU=",
    "name": "burgerBuilderApp",
    "full_name": "girishgodage/burgerBuilderApp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/burgerBuilderApp",
    "description": "React burgerBuilderApp ",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/burgerBuilderApp",
    "forks_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/burgerBuilderApp/deployments",
    "created_at": "2018-07-07T09:47:34Z",
    "updated_at": "2018-07-07T09:47:34Z",
    "pushed_at": "2018-07-07T09:47:35Z",
    "git_url": "git://github.com/girishgodage/burgerBuilderApp.git",
    "ssh_url": "git@github.com:girishgodage/burgerBuilderApp.git",
    "clone_url": "https://github.com/girishgodage/burgerBuilderApp.git",
    "svn_url": "https://github.com/girishgodage/burgerBuilderApp",
    "homepage": null,
    "size": 0,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 239314839,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzkzMTQ4Mzk=",
    "name": "CardioGoodFitness---Descriptive-Statistics",
    "full_name": "girishgodage/CardioGoodFitness---Descriptive-Statistics",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/CardioGoodFitness---Descriptive-Statistics",
    "description": "Cardio Good Fitness Case Study - Descriptive Statistics",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics",
    "forks_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/CardioGoodFitness---Descriptive-Statistics/deployments",
    "created_at": "2020-02-09T14:06:53Z",
    "updated_at": "2020-02-09T14:06:55Z",
    "pushed_at": "2019-12-08T15:30:13Z",
    "git_url": "git://github.com/girishgodage/CardioGoodFitness---Descriptive-Statistics.git",
    "ssh_url": "git@github.com:girishgodage/CardioGoodFitness---Descriptive-Statistics.git",
    "clone_url": "https://github.com/girishgodage/CardioGoodFitness---Descriptive-Statistics.git",
    "svn_url": "https://github.com/girishgodage/CardioGoodFitness---Descriptive-Statistics",
    "homepage": null,
    "size": 206,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 328925741,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjg5MjU3NDE=",
    "name": "chatapp",
    "full_name": "girishgodage/chatapp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/chatapp",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/chatapp",
    "forks_url": "https://api.github.com/repos/girishgodage/chatapp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/chatapp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/chatapp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/chatapp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/chatapp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/chatapp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/chatapp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/chatapp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/chatapp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/chatapp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/chatapp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/chatapp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/chatapp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/chatapp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/chatapp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/chatapp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/chatapp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/chatapp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/chatapp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/chatapp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/chatapp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/chatapp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/chatapp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/chatapp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/chatapp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/chatapp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/chatapp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/chatapp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/chatapp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/chatapp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/chatapp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/chatapp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/chatapp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/chatapp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/chatapp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/chatapp/deployments",
    "created_at": "2021-01-12T08:51:53Z",
    "updated_at": "2021-01-12T09:07:46Z",
    "pushed_at": "2021-01-12T09:07:44Z",
    "git_url": "git://github.com/girishgodage/chatapp.git",
    "ssh_url": "git@github.com:girishgodage/chatapp.git",
    "clone_url": "https://github.com/girishgodage/chatapp.git",
    "svn_url": "https://github.com/girishgodage/chatapp",
    "homepage": null,
    "size": 791,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 246727278,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDY3MjcyNzg=",
    "name": "cinema-microservice",
    "full_name": "girishgodage/cinema-microservice",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/cinema-microservice",
    "description": "Example of a cinema microservice",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/cinema-microservice",
    "forks_url": "https://api.github.com/repos/girishgodage/cinema-microservice/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/cinema-microservice/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/cinema-microservice/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/cinema-microservice/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/cinema-microservice/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/cinema-microservice/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/cinema-microservice/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/cinema-microservice/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/cinema-microservice/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/cinema-microservice/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/cinema-microservice/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/cinema-microservice/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/cinema-microservice/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/cinema-microservice/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/cinema-microservice/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/cinema-microservice/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/cinema-microservice/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/cinema-microservice/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/cinema-microservice/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/cinema-microservice/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/cinema-microservice/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/cinema-microservice/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/cinema-microservice/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/cinema-microservice/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/cinema-microservice/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/cinema-microservice/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/cinema-microservice/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/cinema-microservice/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/cinema-microservice/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/cinema-microservice/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/cinema-microservice/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/cinema-microservice/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/cinema-microservice/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/cinema-microservice/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/cinema-microservice/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/cinema-microservice/deployments",
    "created_at": "2020-03-12T02:39:43Z",
    "updated_at": "2020-03-12T02:39:45Z",
    "pushed_at": "2019-10-29T20:33:40Z",
    "git_url": "git://github.com/girishgodage/cinema-microservice.git",
    "ssh_url": "git@github.com:girishgodage/cinema-microservice.git",
    "clone_url": "https://github.com/girishgodage/cinema-microservice.git",
    "svn_url": "https://github.com/girishgodage/cinema-microservice",
    "homepage": null,
    "size": 871,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 217708908,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTc3MDg5MDg=",
    "name": "Clinic-Management-System-ASP.NET",
    "full_name": "girishgodage/Clinic-Management-System-ASP.NET",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Clinic-Management-System-ASP.NET",
    "description": "👨‍⚕️ A fully featured Clinic Management System based on three tier architecture made using ASP.NET, C# with a well documented README.md file.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET",
    "forks_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Clinic-Management-System-ASP.NET/deployments",
    "created_at": "2019-10-26T12:57:07Z",
    "updated_at": "2019-10-26T12:57:08Z",
    "pushed_at": "2019-10-09T09:31:13Z",
    "git_url": "git://github.com/girishgodage/Clinic-Management-System-ASP.NET.git",
    "ssh_url": "git@github.com:girishgodage/Clinic-Management-System-ASP.NET.git",
    "clone_url": "https://github.com/girishgodage/Clinic-Management-System-ASP.NET.git",
    "svn_url": "https://github.com/girishgodage/Clinic-Management-System-ASP.NET",
    "homepage": "",
    "size": 23114,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 332750777,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMzI3NTA3Nzc=",
    "name": "codepen",
    "full_name": "girishgodage/codepen",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/codepen",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/codepen",
    "forks_url": "https://api.github.com/repos/girishgodage/codepen/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/codepen/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/codepen/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/codepen/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/codepen/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/codepen/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/codepen/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/codepen/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/codepen/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/codepen/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/codepen/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/codepen/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/codepen/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/codepen/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/codepen/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/codepen/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/codepen/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/codepen/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/codepen/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/codepen/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/codepen/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/codepen/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/codepen/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/codepen/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/codepen/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/codepen/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/codepen/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/codepen/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/codepen/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/codepen/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/codepen/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/codepen/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/codepen/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/codepen/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/codepen/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/codepen/deployments",
    "created_at": "2021-01-25T13:09:32Z",
    "updated_at": "2021-01-25T13:15:09Z",
    "pushed_at": "2021-01-25T13:30:22Z",
    "git_url": "git://github.com/girishgodage/codepen.git",
    "ssh_url": "git@github.com:girishgodage/codepen.git",
    "clone_url": "https://github.com/girishgodage/codepen.git",
    "svn_url": "https://github.com/girishgodage/codepen",
    "homepage": null,
    "size": 1588,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 194367715,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTQzNjc3MTU=",
    "name": "config-repo",
    "full_name": "girishgodage/config-repo",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/config-repo",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/config-repo",
    "forks_url": "https://api.github.com/repos/girishgodage/config-repo/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/config-repo/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/config-repo/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/config-repo/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/config-repo/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/config-repo/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/config-repo/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/config-repo/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/config-repo/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/config-repo/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/config-repo/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/config-repo/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/config-repo/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/config-repo/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/config-repo/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/config-repo/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/config-repo/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/config-repo/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/config-repo/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/config-repo/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/config-repo/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/config-repo/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/config-repo/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/config-repo/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/config-repo/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/config-repo/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/config-repo/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/config-repo/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/config-repo/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/config-repo/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/config-repo/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/config-repo/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/config-repo/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/config-repo/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/config-repo/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/config-repo/deployments",
    "created_at": "2019-06-29T05:22:51Z",
    "updated_at": "2019-06-29T05:32:09Z",
    "pushed_at": "2019-06-29T05:32:07Z",
    "git_url": "git://github.com/girishgodage/config-repo.git",
    "ssh_url": "git@github.com:girishgodage/config-repo.git",
    "clone_url": "https://github.com/girishgodage/config-repo.git",
    "svn_url": "https://github.com/girishgodage/config-repo",
    "homepage": null,
    "size": 43,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 218980280,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTg5ODAyODA=",
    "name": "confplanerapp",
    "full_name": "girishgodage/confplanerapp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/confplanerapp",
    "description": "conference planner app in .net core 3.0",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/confplanerapp",
    "forks_url": "https://api.github.com/repos/girishgodage/confplanerapp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/confplanerapp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/confplanerapp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/confplanerapp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/confplanerapp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/confplanerapp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/confplanerapp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/confplanerapp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/confplanerapp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/confplanerapp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/confplanerapp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/confplanerapp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/confplanerapp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/confplanerapp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/confplanerapp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/confplanerapp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/confplanerapp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/confplanerapp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/confplanerapp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/confplanerapp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/confplanerapp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/confplanerapp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/confplanerapp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/confplanerapp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/confplanerapp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/confplanerapp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/confplanerapp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/confplanerapp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/confplanerapp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/confplanerapp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/confplanerapp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/confplanerapp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/confplanerapp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/confplanerapp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/confplanerapp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/confplanerapp/deployments",
    "created_at": "2019-11-01T12:21:51Z",
    "updated_at": "2019-11-01T12:57:13Z",
    "pushed_at": "2019-11-01T12:57:11Z",
    "git_url": "git://github.com/girishgodage/confplanerapp.git",
    "ssh_url": "git@github.com:girishgodage/confplanerapp.git",
    "clone_url": "https://github.com/girishgodage/confplanerapp.git",
    "svn_url": "https://github.com/girishgodage/confplanerapp",
    "homepage": null,
    "size": 20442,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224436470,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzY0NzA=",
    "name": "Contact-Manager",
    "full_name": "girishgodage/Contact-Manager",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Contact-Manager",
    "description": "Asp.Net Example of Contact Manager Web App showing Asp.Net Core 2 Mvc capability and AJAX JQuery based CRUD.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Contact-Manager",
    "forks_url": "https://api.github.com/repos/girishgodage/Contact-Manager/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Contact-Manager/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Contact-Manager/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Contact-Manager/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Contact-Manager/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Contact-Manager/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Contact-Manager/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Contact-Manager/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Contact-Manager/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Contact-Manager/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Contact-Manager/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Contact-Manager/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Contact-Manager/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Contact-Manager/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Contact-Manager/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Contact-Manager/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Contact-Manager/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Contact-Manager/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Contact-Manager/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Contact-Manager/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Contact-Manager/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Contact-Manager/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Contact-Manager/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Contact-Manager/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Contact-Manager/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Contact-Manager/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Contact-Manager/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Contact-Manager/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Contact-Manager/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Contact-Manager/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Contact-Manager/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Contact-Manager/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Contact-Manager/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Contact-Manager/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Contact-Manager/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Contact-Manager/deployments",
    "created_at": "2019-11-27T13:24:04Z",
    "updated_at": "2019-11-27T13:24:06Z",
    "pushed_at": "2018-07-28T14:22:50Z",
    "git_url": "git://github.com/girishgodage/Contact-Manager.git",
    "ssh_url": "git@github.com:girishgodage/Contact-Manager.git",
    "clone_url": "https://github.com/girishgodage/Contact-Manager.git",
    "svn_url": "https://github.com/girishgodage/Contact-Manager",
    "homepage": "",
    "size": 735,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 96297798,
    "node_id": "MDEwOlJlcG9zaXRvcnk5NjI5Nzc5OA==",
    "name": "contactapp",
    "full_name": "girishgodage/contactapp",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/contactapp",
    "description": " ROR Contact app",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/contactapp",
    "forks_url": "https://api.github.com/repos/girishgodage/contactapp/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/contactapp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/contactapp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/contactapp/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/contactapp/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/contactapp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/contactapp/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/contactapp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/contactapp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/contactapp/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/contactapp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/contactapp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/contactapp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/contactapp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/contactapp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/contactapp/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/contactapp/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/contactapp/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/contactapp/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/contactapp/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/contactapp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/contactapp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/contactapp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/contactapp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/contactapp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/contactapp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/contactapp/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/contactapp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/contactapp/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/contactapp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/contactapp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/contactapp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/contactapp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/contactapp/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/contactapp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/contactapp/deployments",
    "created_at": "2017-07-05T08:45:22Z",
    "updated_at": "2017-07-05T09:13:58Z",
    "pushed_at": "2017-07-05T09:13:57Z",
    "git_url": "git://github.com/girishgodage/contactapp.git",
    "ssh_url": "git@github.com:girishgodage/contactapp.git",
    "clone_url": "https://github.com/girishgodage/contactapp.git",
    "svn_url": "https://github.com/girishgodage/contactapp",
    "homepage": null,
    "size": 46,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Ruby",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 148957727,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDg5NTc3Mjc=",
    "name": "ContosoUniversityDotNetCore",
    "full_name": "girishgodage/ContosoUniversityDotNetCore",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/ContosoUniversityDotNetCore",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore",
    "forks_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/ContosoUniversityDotNetCore/deployments",
    "created_at": "2018-09-16T02:53:41Z",
    "updated_at": "2018-09-16T02:53:44Z",
    "pushed_at": "2018-09-14T09:48:30Z",
    "git_url": "git://github.com/girishgodage/ContosoUniversityDotNetCore.git",
    "ssh_url": "git@github.com:girishgodage/ContosoUniversityDotNetCore.git",
    "clone_url": "https://github.com/girishgodage/ContosoUniversityDotNetCore.git",
    "svn_url": "https://github.com/girishgodage/ContosoUniversityDotNetCore",
    "homepage": null,
    "size": 4561,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 144583599,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDQ1ODM1OTk=",
    "name": "coolstore-microservices",
    "full_name": "girishgodage/coolstore-microservices",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/coolstore-microservices",
    "description": ":ferris_wheel: :sailboat: :ship: A containerized polyglot microservices consisting of services based on .NET Core, NodeJS and more running on service mesh (istio). ",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/coolstore-microservices",
    "forks_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/coolstore-microservices/deployments",
    "created_at": "2018-08-13T13:28:38Z",
    "updated_at": "2018-08-13T13:28:41Z",
    "pushed_at": "2018-08-13T06:45:13Z",
    "git_url": "git://github.com/girishgodage/coolstore-microservices.git",
    "ssh_url": "git@github.com:girishgodage/coolstore-microservices.git",
    "clone_url": "https://github.com/girishgodage/coolstore-microservices.git",
    "svn_url": "https://github.com/girishgodage/coolstore-microservices",
    "homepage": "",
    "size": 7090,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 188524233,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODg1MjQyMzM=",
    "name": "core-microservices-template",
    "full_name": "girishgodage/core-microservices-template",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/core-microservices-template",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/core-microservices-template",
    "forks_url": "https://api.github.com/repos/girishgodage/core-microservices-template/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/core-microservices-template/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/core-microservices-template/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/core-microservices-template/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/core-microservices-template/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/core-microservices-template/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/core-microservices-template/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/core-microservices-template/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/core-microservices-template/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/core-microservices-template/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/core-microservices-template/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/core-microservices-template/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/core-microservices-template/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/core-microservices-template/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/core-microservices-template/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/core-microservices-template/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/core-microservices-template/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/core-microservices-template/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/core-microservices-template/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/core-microservices-template/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/core-microservices-template/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/core-microservices-template/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/core-microservices-template/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/core-microservices-template/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/core-microservices-template/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/core-microservices-template/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/core-microservices-template/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/core-microservices-template/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/core-microservices-template/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/core-microservices-template/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/core-microservices-template/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/core-microservices-template/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/core-microservices-template/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/core-microservices-template/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/core-microservices-template/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/core-microservices-template/deployments",
    "created_at": "2019-05-25T05:22:37Z",
    "updated_at": "2019-05-25T05:22:39Z",
    "pushed_at": "2018-04-24T07:12:18Z",
    "git_url": "git://github.com/girishgodage/core-microservices-template.git",
    "ssh_url": "git@github.com:girishgodage/core-microservices-template.git",
    "clone_url": "https://github.com/girishgodage/core-microservices-template.git",
    "svn_url": "https://github.com/girishgodage/core-microservices-template",
    "homepage": null,
    "size": 58,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "develop"
  },
  {
    "id": 243213258,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDMyMTMyNTg=",
    "name": "coreui-free-angular-admin-template",
    "full_name": "girishgodage/coreui-free-angular-admin-template",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/coreui-free-angular-admin-template",
    "description": "CoreUI Angular is free Angular 2+ admin template based on Bootstrap 4",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template",
    "forks_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/coreui-free-angular-admin-template/deployments",
    "created_at": "2020-02-26T08:44:10Z",
    "updated_at": "2020-02-26T08:44:12Z",
    "pushed_at": "2020-02-11T12:47:19Z",
    "git_url": "git://github.com/girishgodage/coreui-free-angular-admin-template.git",
    "ssh_url": "git@github.com:girishgodage/coreui-free-angular-admin-template.git",
    "clone_url": "https://github.com/girishgodage/coreui-free-angular-admin-template.git",
    "svn_url": "https://github.com/girishgodage/coreui-free-angular-admin-template",
    "homepage": "http://coreui.io/angular/",
    "size": 2662,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 207546757,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDc1NDY3NTc=",
    "name": "Courses",
    "full_name": "girishgodage/Courses",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Courses",
    "description": "Solutions to programming assignments",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Courses",
    "forks_url": "https://api.github.com/repos/girishgodage/Courses/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Courses/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Courses/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Courses/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Courses/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Courses/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Courses/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Courses/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Courses/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Courses/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Courses/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Courses/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Courses/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Courses/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Courses/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Courses/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Courses/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Courses/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Courses/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Courses/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Courses/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Courses/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Courses/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Courses/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Courses/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Courses/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Courses/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Courses/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Courses/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Courses/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Courses/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Courses/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Courses/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Courses/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Courses/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Courses/deployments",
    "created_at": "2019-09-10T11:56:54Z",
    "updated_at": "2019-09-10T11:56:56Z",
    "pushed_at": "2019-01-26T06:00:27Z",
    "git_url": "git://github.com/girishgodage/Courses.git",
    "ssh_url": "git@github.com:girishgodage/Courses.git",
    "clone_url": "https://github.com/girishgodage/Courses.git",
    "svn_url": "https://github.com/girishgodage/Courses",
    "homepage": null,
    "size": 221306,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 251499657,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTE0OTk2NTc=",
    "name": "COVID-19",
    "full_name": "girishgodage/COVID-19",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/COVID-19",
    "description": "Novel Coronavirus (COVID-19) Cases, provided by JHU CSSE",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/COVID-19",
    "forks_url": "https://api.github.com/repos/girishgodage/COVID-19/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/COVID-19/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/COVID-19/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/COVID-19/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/COVID-19/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/COVID-19/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/COVID-19/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/COVID-19/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/COVID-19/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/COVID-19/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/COVID-19/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/COVID-19/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/COVID-19/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/COVID-19/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/COVID-19/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/COVID-19/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/COVID-19/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/COVID-19/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/COVID-19/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/COVID-19/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/COVID-19/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/COVID-19/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/COVID-19/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/COVID-19/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/COVID-19/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/COVID-19/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/COVID-19/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/COVID-19/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/COVID-19/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/COVID-19/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/COVID-19/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/COVID-19/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/COVID-19/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/COVID-19/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/COVID-19/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/COVID-19/deployments",
    "created_at": "2020-03-31T04:23:28Z",
    "updated_at": "2020-03-31T04:23:29Z",
    "pushed_at": "2020-03-31T03:39:59Z",
    "git_url": "git://github.com/girishgodage/COVID-19.git",
    "ssh_url": "git@github.com:girishgodage/COVID-19.git",
    "clone_url": "https://github.com/girishgodage/COVID-19.git",
    "svn_url": "https://github.com/girishgodage/COVID-19",
    "homepage": "https://systems.jhu.edu/research/public-health/ncov/",
    "size": 67904,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 251512475,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTE1MTI0NzU=",
    "name": "covid19india-react",
    "full_name": "girishgodage/covid19india-react",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/covid19india-react",
    "description": "📊 Source code of the main website",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/covid19india-react",
    "forks_url": "https://api.github.com/repos/girishgodage/covid19india-react/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/covid19india-react/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/covid19india-react/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/covid19india-react/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/covid19india-react/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/covid19india-react/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/covid19india-react/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/covid19india-react/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/covid19india-react/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/covid19india-react/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/covid19india-react/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/covid19india-react/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/covid19india-react/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/covid19india-react/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/covid19india-react/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/covid19india-react/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/covid19india-react/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/covid19india-react/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/covid19india-react/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/covid19india-react/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/covid19india-react/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/covid19india-react/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/covid19india-react/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/covid19india-react/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/covid19india-react/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/covid19india-react/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/covid19india-react/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/covid19india-react/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/covid19india-react/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/covid19india-react/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/covid19india-react/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/covid19india-react/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/covid19india-react/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/covid19india-react/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/covid19india-react/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/covid19india-react/deployments",
    "created_at": "2020-03-31T05:51:13Z",
    "updated_at": "2020-03-31T05:51:15Z",
    "pushed_at": "2020-03-31T05:08:42Z",
    "git_url": "git://github.com/girishgodage/covid19india-react.git",
    "ssh_url": "git@github.com:girishgodage/covid19india-react.git",
    "clone_url": "https://github.com/girishgodage/covid19india-react.git",
    "svn_url": "https://github.com/girishgodage/covid19india-react",
    "homepage": "https://www.covid19india.org",
    "size": 19381,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 325182939,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjUxODI5Mzk=",
    "name": "Covid19Tracker",
    "full_name": "girishgodage/Covid19Tracker",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Covid19Tracker",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/Covid19Tracker",
    "forks_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Covid19Tracker/deployments",
    "created_at": "2020-12-29T04:11:01Z",
    "updated_at": "2021-01-19T09:51:16Z",
    "pushed_at": "2020-12-29T07:47:25Z",
    "git_url": "git://github.com/girishgodage/Covid19Tracker.git",
    "ssh_url": "git@github.com:girishgodage/Covid19Tracker.git",
    "clone_url": "https://github.com/girishgodage/Covid19Tracker.git",
    "svn_url": "https://github.com/girishgodage/Covid19Tracker",
    "homepage": null,
    "size": 512,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 216232836,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTYyMzI4MzY=",
    "name": "curioswati.github.io",
    "full_name": "girishgodage/curioswati.github.io",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/curioswati.github.io",
    "description": "My blog",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/curioswati.github.io",
    "forks_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/curioswati.github.io/deployments",
    "created_at": "2019-10-19T16:04:12Z",
    "updated_at": "2019-10-19T16:04:14Z",
    "pushed_at": "2019-07-02T19:06:00Z",
    "git_url": "git://github.com/girishgodage/curioswati.github.io.git",
    "ssh_url": "git@github.com:girishgodage/curioswati.github.io.git",
    "clone_url": "https://github.com/girishgodage/curioswati.github.io.git",
    "svn_url": "https://github.com/girishgodage/curioswati.github.io",
    "homepage": "https://swatij.me",
    "size": 1170,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 254016461,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTQwMTY0NjE=",
    "name": "DataTables",
    "full_name": "girishgodage/DataTables",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/DataTables",
    "description": "Tables plug-in for jQuery",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/DataTables",
    "forks_url": "https://api.github.com/repos/girishgodage/DataTables/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/DataTables/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/DataTables/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/DataTables/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/DataTables/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/DataTables/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/DataTables/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/DataTables/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/DataTables/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/DataTables/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/DataTables/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/DataTables/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/DataTables/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/DataTables/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/DataTables/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/DataTables/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/DataTables/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/DataTables/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/DataTables/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/DataTables/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/DataTables/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/DataTables/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/DataTables/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/DataTables/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/DataTables/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/DataTables/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/DataTables/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/DataTables/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/DataTables/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/DataTables/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/DataTables/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/DataTables/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/DataTables/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/DataTables/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/DataTables/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/DataTables/deployments",
    "created_at": "2020-04-08T07:30:03Z",
    "updated_at": "2020-04-08T07:30:05Z",
    "pushed_at": "2020-03-14T08:33:14Z",
    "git_url": "git://github.com/girishgodage/DataTables.git",
    "ssh_url": "git@github.com:girishgodage/DataTables.git",
    "clone_url": "https://github.com/girishgodage/DataTables.git",
    "svn_url": "https://github.com/girishgodage/DataTables",
    "homepage": "http://www.datatables.net/",
    "size": 12028,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 139099601,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzkwOTk2MDE=",
    "name": "DI-Demo",
    "full_name": "girishgodage/DI-Demo",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/DI-Demo",
    "description": "Demo of DI options in spring",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/DI-Demo",
    "forks_url": "https://api.github.com/repos/girishgodage/DI-Demo/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/DI-Demo/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/DI-Demo/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/DI-Demo/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/DI-Demo/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/DI-Demo/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/DI-Demo/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/DI-Demo/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/DI-Demo/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/DI-Demo/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/DI-Demo/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/DI-Demo/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/DI-Demo/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/DI-Demo/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/DI-Demo/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/DI-Demo/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/DI-Demo/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/DI-Demo/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/DI-Demo/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/DI-Demo/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/DI-Demo/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/DI-Demo/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/DI-Demo/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/DI-Demo/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/DI-Demo/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/DI-Demo/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/DI-Demo/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/DI-Demo/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/DI-Demo/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/DI-Demo/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/DI-Demo/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/DI-Demo/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/DI-Demo/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/DI-Demo/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/DI-Demo/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/DI-Demo/deployments",
    "created_at": "2018-06-29T04:09:50Z",
    "updated_at": "2018-07-13T06:04:00Z",
    "pushed_at": "2018-07-13T06:03:58Z",
    "git_url": "git://github.com/girishgodage/DI-Demo.git",
    "ssh_url": "git@github.com:girishgodage/DI-Demo.git",
    "clone_url": "https://github.com/girishgodage/DI-Demo.git",
    "svn_url": "https://github.com/girishgodage/DI-Demo",
    "homepage": null,
    "size": 57,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 316208038,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMTYyMDgwMzg=",
    "name": "Docker-DotNetCore-SqlServer",
    "full_name": "girishgodage/Docker-DotNetCore-SqlServer",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Docker-DotNetCore-SqlServer",
    "description": "Sample to demonstrate setting up docker with .Net core API and Sql Server",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer",
    "forks_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Docker-DotNetCore-SqlServer/deployments",
    "created_at": "2020-11-26T11:19:30Z",
    "updated_at": "2020-11-26T11:19:32Z",
    "pushed_at": "2020-08-16T20:44:34Z",
    "git_url": "git://github.com/girishgodage/Docker-DotNetCore-SqlServer.git",
    "ssh_url": "git@github.com:girishgodage/Docker-DotNetCore-SqlServer.git",
    "clone_url": "https://github.com/girishgodage/Docker-DotNetCore-SqlServer.git",
    "svn_url": "https://github.com/girishgodage/Docker-DotNetCore-SqlServer",
    "homepage": null,
    "size": 3422,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 148350573,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDgzNTA1NzM=",
    "name": "Docs",
    "full_name": "girishgodage/Docs",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Docs",
    "description": "Documentation for ASP.NET and ASP.NET Core",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Docs",
    "forks_url": "https://api.github.com/repos/girishgodage/Docs/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Docs/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Docs/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Docs/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Docs/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Docs/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Docs/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Docs/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Docs/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Docs/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Docs/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Docs/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Docs/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Docs/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Docs/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Docs/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Docs/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Docs/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Docs/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Docs/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Docs/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Docs/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Docs/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Docs/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Docs/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Docs/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Docs/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Docs/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Docs/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Docs/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Docs/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Docs/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Docs/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Docs/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Docs/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Docs/deployments",
    "created_at": "2018-09-11T16:58:56Z",
    "updated_at": "2020-02-19T21:27:20Z",
    "pushed_at": "2018-09-11T16:37:52Z",
    "git_url": "git://github.com/girishgodage/Docs.git",
    "ssh_url": "git@github.com:girishgodage/Docs.git",
    "clone_url": "https://github.com/girishgodage/Docs.git",
    "svn_url": "https://github.com/girishgodage/Docs",
    "homepage": "https://docs.microsoft.com/aspnet",
    "size": 686147,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 224432582,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzI1ODI=",
    "name": "DotnetDesk",
    "full_name": "girishgodage/DotnetDesk",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/DotnetDesk",
    "description": "Asp.Net Example web application showing the capabilities of ASP.NET Core 2 MVC, EF (Entity Framework), Web API, Bootstrap, jQuery, datatables, adminlte template and many more. Web app created as helpdesk or ticket support portal.",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/DotnetDesk",
    "forks_url": "https://api.github.com/repos/girishgodage/DotnetDesk/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/DotnetDesk/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/DotnetDesk/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/DotnetDesk/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/DotnetDesk/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/DotnetDesk/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/DotnetDesk/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/DotnetDesk/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/DotnetDesk/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/DotnetDesk/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/DotnetDesk/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/DotnetDesk/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/DotnetDesk/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/DotnetDesk/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/DotnetDesk/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/DotnetDesk/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/DotnetDesk/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/DotnetDesk/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/DotnetDesk/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/DotnetDesk/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/DotnetDesk/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/DotnetDesk/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/DotnetDesk/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/DotnetDesk/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/DotnetDesk/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/DotnetDesk/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/DotnetDesk/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/DotnetDesk/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/DotnetDesk/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/DotnetDesk/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/DotnetDesk/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/DotnetDesk/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/DotnetDesk/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/DotnetDesk/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/DotnetDesk/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/DotnetDesk/deployments",
    "created_at": "2019-11-27T13:03:12Z",
    "updated_at": "2019-11-27T13:03:14Z",
    "pushed_at": "2019-05-06T00:55:12Z",
    "git_url": "git://github.com/girishgodage/DotnetDesk.git",
    "ssh_url": "git@github.com:girishgodage/DotnetDesk.git",
    "clone_url": "https://github.com/girishgodage/DotnetDesk.git",
    "svn_url": "https://github.com/girishgodage/DotnetDesk",
    "homepage": "",
    "size": 18571,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 143825137,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDM4MjUxMzc=",
    "name": "DrinkAndGo",
    "full_name": "girishgodage/DrinkAndGo",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/DrinkAndGo",
    "description": ".net Core eCommerce web Application",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/DrinkAndGo",
    "forks_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/DrinkAndGo/deployments",
    "created_at": "2018-08-07T05:42:04Z",
    "updated_at": "2018-08-07T05:48:32Z",
    "pushed_at": "2018-08-07T05:48:29Z",
    "git_url": "git://github.com/girishgodage/DrinkAndGo.git",
    "ssh_url": "git@github.com:girishgodage/DrinkAndGo.git",
    "clone_url": "https://github.com/girishgodage/DrinkAndGo.git",
    "svn_url": "https://github.com/girishgodage/DrinkAndGo",
    "homepage": null,
    "size": 4604,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 209282361,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDkyODIzNjE=",
    "name": "eCom",
    "full_name": "girishgodage/eCom",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/eCom",
    "description": "django ecommerce Website",
    "fork": false,
    "url": "https://api.github.com/repos/girishgodage/eCom",
    "forks_url": "https://api.github.com/repos/girishgodage/eCom/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/eCom/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/eCom/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/eCom/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/eCom/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/eCom/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/eCom/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/eCom/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/eCom/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/eCom/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/eCom/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/eCom/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/eCom/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/eCom/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/eCom/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/eCom/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/eCom/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/eCom/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/eCom/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/eCom/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/eCom/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/eCom/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/eCom/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/eCom/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/eCom/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/eCom/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/eCom/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/eCom/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/eCom/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/eCom/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/eCom/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/eCom/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/eCom/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/eCom/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/eCom/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/eCom/deployments",
    "created_at": "2019-09-18T10:34:44Z",
    "updated_at": "2019-09-19T05:08:25Z",
    "pushed_at": "2019-09-19T05:08:23Z",
    "git_url": "git://github.com/girishgodage/eCom.git",
    "ssh_url": "git@github.com:girishgodage/eCom.git",
    "clone_url": "https://github.com/girishgodage/eCom.git",
    "svn_url": "https://github.com/girishgodage/eCom",
    "homepage": null,
    "size": 3452,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 232475065,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzI0NzUwNjU=",
    "name": "Edureka-Microservices",
    "full_name": "girishgodage/Edureka-Microservices",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/Edureka-Microservices",
    "description": "Microservice Project build on Spring Boot, Spring Cloud Netflix, Oauth, Zuul Proxy/API Gateway, Eureka Server, JMS(ActiveMQ), Swagger with H2 ",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/Edureka-Microservices",
    "forks_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/Edureka-Microservices/deployments",
    "created_at": "2020-01-08T04:07:46Z",
    "updated_at": "2020-01-08T04:07:48Z",
    "pushed_at": "2019-03-10T04:33:59Z",
    "git_url": "git://github.com/girishgodage/Edureka-Microservices.git",
    "ssh_url": "git@github.com:girishgodage/Edureka-Microservices.git",
    "clone_url": "https://github.com/girishgodage/Edureka-Microservices.git",
    "svn_url": "https://github.com/girishgodage/Edureka-Microservices",
    "homepage": "",
    "size": 90197,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 204407455,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMDQ0MDc0NTU=",
    "name": "EdurekaPython",
    "full_name": "girishgodage/EdurekaPython",
    "private": false,
    "owner": {
      "login": "girishgodage",
      "id": 10049525,
      "node_id": "MDQ6VXNlcjEwMDQ5NTI1",
      "avatar_url": "https://avatars.githubusercontent.com/u/10049525?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/girishgodage",
      "html_url": "https://github.com/girishgodage",
      "followers_url": "https://api.github.com/users/girishgodage/followers",
      "following_url": "https://api.github.com/users/girishgodage/following{/other_user}",
      "gists_url": "https://api.github.com/users/girishgodage/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/girishgodage/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/girishgodage/subscriptions",
      "organizations_url": "https://api.github.com/users/girishgodage/orgs",
      "repos_url": "https://api.github.com/users/girishgodage/repos",
      "events_url": "https://api.github.com/users/girishgodage/events{/privacy}",
      "received_events_url": "https://api.github.com/users/girishgodage/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/girishgodage/EdurekaPython",
    "description": "Repository for Python for DataScience in Edureka",
    "fork": true,
    "url": "https://api.github.com/repos/girishgodage/EdurekaPython",
    "forks_url": "https://api.github.com/repos/girishgodage/EdurekaPython/forks",
    "keys_url": "https://api.github.com/repos/girishgodage/EdurekaPython/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/girishgodage/EdurekaPython/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/girishgodage/EdurekaPython/teams",
    "hooks_url": "https://api.github.com/repos/girishgodage/EdurekaPython/hooks",
    "issue_events_url": "https://api.github.com/repos/girishgodage/EdurekaPython/issues/events{/number}",
    "events_url": "https://api.github.com/repos/girishgodage/EdurekaPython/events",
    "assignees_url": "https://api.github.com/repos/girishgodage/EdurekaPython/assignees{/user}",
    "branches_url": "https://api.github.com/repos/girishgodage/EdurekaPython/branches{/branch}",
    "tags_url": "https://api.github.com/repos/girishgodage/EdurekaPython/tags",
    "blobs_url": "https://api.github.com/repos/girishgodage/EdurekaPython/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/girishgodage/EdurekaPython/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/girishgodage/EdurekaPython/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/girishgodage/EdurekaPython/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/girishgodage/EdurekaPython/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/girishgodage/EdurekaPython/languages",
    "stargazers_url": "https://api.github.com/repos/girishgodage/EdurekaPython/stargazers",
    "contributors_url": "https://api.github.com/repos/girishgodage/EdurekaPython/contributors",
    "subscribers_url": "https://api.github.com/repos/girishgodage/EdurekaPython/subscribers",
    "subscription_url": "https://api.github.com/repos/girishgodage/EdurekaPython/subscription",
    "commits_url": "https://api.github.com/repos/girishgodage/EdurekaPython/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/girishgodage/EdurekaPython/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/girishgodage/EdurekaPython/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/girishgodage/EdurekaPython/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/girishgodage/EdurekaPython/contents/{+path}",
    "compare_url": "https://api.github.com/repos/girishgodage/EdurekaPython/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/girishgodage/EdurekaPython/merges",
    "archive_url": "https://api.github.com/repos/girishgodage/EdurekaPython/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/girishgodage/EdurekaPython/downloads",
    "issues_url": "https://api.github.com/repos/girishgodage/EdurekaPython/issues{/number}",
    "pulls_url": "https://api.github.com/repos/girishgodage/EdurekaPython/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/girishgodage/EdurekaPython/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/girishgodage/EdurekaPython/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/girishgodage/EdurekaPython/labels{/name}",
    "releases_url": "https://api.github.com/repos/girishgodage/EdurekaPython/releases{/id}",
    "deployments_url": "https://api.github.com/repos/girishgodage/EdurekaPython/deployments",
    "created_at": "2019-08-26T06:09:50Z",
    "updated_at": "2019-08-26T06:09:54Z",
    "pushed_at": "2018-09-06T07:22:00Z",
    "git_url": "git://github.com/girishgodage/EdurekaPython.git",
    "ssh_url": "git@github.com:girishgodage/EdurekaPython.git",
    "clone_url": "https://github.com/girishgodage/EdurekaPython.git",
    "svn_url": "https://github.com/girishgodage/EdurekaPython",
    "homepage": null,
    "size": 17248,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Jupyter Notebook",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
];
